var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignInFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 448,
    viewBox: "0 0 600 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600 393.16H0V393.46H600V393.16Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.88 412.478H500.136V412.778H539.88V412.478Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.464 415.744H387.036V416.044H397.464V415.744Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.936 401.337H475.908V401.637H498.936V401.337Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78 403.353H62.9519V403.653H114.78V403.353Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.068 403.353H125.472V403.653H133.068V403.353Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.18 408.42H157.764V408.721H270.18V408.42Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.412 339.609H52.704C48.924 339.609 45.8521 336.536 45.8521 332.754V6.85582C45.8521 3.07371 48.924 0 52.704 0H284.424C288.204 0 291.276 3.07371 291.276 6.85582V332.754C291.264 336.536 288.192 339.609 284.412 339.609ZM52.704 0.300167C49.092 0.300167 46.1521 3.24181 46.1521 6.85582V332.754C46.1521 336.368 49.092 339.309 52.704 339.309H284.424C288.036 339.309 290.976 336.368 290.976 332.754V6.85582C290.976 3.24181 288.036 0.300167 284.424 0.300167H52.704Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.972 339.609H312.252C308.472 339.609 305.4 336.536 305.4 332.754V6.85582C305.4 3.07371 308.472 0 312.252 0H543.972C547.752 0 550.824 3.07371 550.824 6.85582V332.754C550.824 336.536 547.752 339.609 543.972 339.609ZM312.252 0.300167C308.64 0.300167 305.7 3.24181 305.7 6.85582V332.754C305.7 336.368 308.64 339.309 312.252 339.309H543.972C547.584 339.309 550.524 336.368 550.524 332.754V6.85582C550.524 3.24181 547.584 0.300167 543.972 0.300167H312.252Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.632 57.2963H95.208V285.327H298.632V57.2963Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.632 60.9697H99.2041V281.281H298.632V60.9697Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.572 177.916V162.427H110.988V152.113H116.88V136.637H118.356V152.113H124.248V162.427H128.664V177.916H136.776V182.334H140.46V199.288H141.192V174.962H143.4V190.439H145.608V153.59H147.084V169.067H152.976V163.904H155.196V142.532H159.612V121.16H161.088V124.102H191.292V115.253H196.44V81.346H198.66V115.253H206.016V124.102H208.968V168.335H224.436V155.067H219.288V152.846H224.436V149.16H239.172V115.253H242.856V110.102H260.532V115.253H262.752V162.427H270.852V183.811H275.268V166.858H278.952V162.427H287.052V146.951H291.48V136.637H296.64V121.16H298.632V281.282H99.2041V177.916H106.572Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.012 126.419H177.924V128.509H180.012V126.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.012 129.913H177.924V132.002H180.012V129.913Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.012 143.924H177.924V146.014H180.012V143.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.012 147.418H177.924V149.507H180.012V147.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.012 150.925H177.924V153.014H180.012V150.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.012 161.429H177.924V163.519H180.012V161.429Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.012 164.925H177.924V167.014H180.012V164.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.324 140.419H181.236V142.508H183.324V140.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.324 143.924H181.236V146.014H183.324V143.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.324 147.418H181.236V149.507H183.324V147.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.324 150.925H181.236V153.014H183.324V150.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.324 154.419H181.236V156.508H183.324V154.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.324 161.429H181.236V163.519H183.324V161.429Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.324 164.925H181.236V167.014H183.324V164.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.636 126.419H184.548V128.509H186.636V126.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.636 129.913H184.548V132.002H186.636V129.913Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.636 133.419H184.548V135.508H186.636V133.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.636 136.912H184.548V139.001H186.636V136.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.636 140.419H184.548V142.508H186.636V140.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.636 143.924H184.548V146.014H186.636V143.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.636 147.418H184.548V149.507H186.636V147.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.636 150.925H184.548V153.014H186.636V150.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.636 154.419H184.548V156.508H186.636V154.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.636 157.924H184.548V160.013H186.636V157.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.636 164.925H184.548V167.014H186.636V164.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.948 126.419H187.86V128.509H189.948V126.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.948 129.913H187.86V132.002H189.948V129.913Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.948 133.419H187.86V135.508H189.948V133.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.948 136.912H187.86V139.001H189.948V136.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.948 140.419H187.86V142.508H189.948V140.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.948 143.924H187.86V146.014H189.948V143.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.948 147.418H187.86V149.507H189.948V147.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.948 178.936H187.86V181.025H189.948V178.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 126.419H191.184V128.509H193.272V126.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 129.913H191.184V132.002H193.272V129.913Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 133.419H191.184V135.508H193.272V133.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 136.912H191.184V139.001H193.272V136.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 140.419H191.184V142.508H193.272V140.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 143.924H191.184V146.014H193.272V143.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 147.418H191.184V149.507H193.272V147.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 150.925H191.184V153.014H193.272V150.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 171.924H191.184V174.013H193.272V171.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 175.431H191.184V177.52H193.272V175.431Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 178.936H191.184V181.025H193.272V178.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 182.43H191.184V184.519H193.272V182.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.272 196.441H191.184V198.53H193.272V196.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 126.419H194.496V128.509H196.584V126.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 129.913H194.496V132.002H196.584V129.913Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 133.419H194.496V135.508H196.584V133.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 136.912H194.496V139.001H196.584V136.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 140.419H194.496V142.508H196.584V140.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 143.924H194.496V146.014H196.584V143.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 147.418H194.496V149.507H196.584V147.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 150.925H194.496V153.014H196.584V150.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 154.419H194.496V156.508H196.584V154.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 157.924H194.496V160.013H196.584V157.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 168.43H194.496V170.519H196.584V168.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 171.924H194.496V174.013H196.584V171.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 175.431H194.496V177.52H196.584V175.431Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 178.936H194.496V181.025H196.584V178.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 182.43H194.496V184.519H196.584V182.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.584 196.441H194.496V198.53H196.584V196.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 126.419H197.808V128.509H199.896V126.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 129.913H197.808V132.002H199.896V129.913Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 133.419H197.808V135.508H199.896V133.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 136.912H197.808V139.001H199.896V136.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 140.419H197.808V142.508H199.896V140.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 143.924H197.808V146.014H199.896V143.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 147.418H197.808V149.507H199.896V147.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 150.925H197.808V153.014H199.896V150.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 154.419H197.808V156.508H199.896V154.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 157.924H197.808V160.013H199.896V157.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 161.429H197.808V163.519H199.896V161.429Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 164.925H197.808V167.014H199.896V164.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 168.43H197.808V170.519H199.896V168.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 171.924H197.808V174.013H199.896V171.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 175.431H197.808V177.52H199.896V175.431Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 178.936H197.808V181.025H199.896V178.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 182.43H197.808V184.519H199.896V182.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.896 185.937H197.808V188.026H199.896V185.937Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 126.419H201.132V128.509H203.22V126.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 129.913H201.132V132.002H203.22V129.913Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 133.419H201.132V135.508H203.22V133.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 136.912H201.132V139.001H203.22V136.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 140.419H201.132V142.508H203.22V140.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 143.924H201.132V146.014H203.22V143.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 147.418H201.132V149.507H203.22V147.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 150.925H201.132V153.014H203.22V150.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 154.419H201.132V156.508H203.22V154.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 157.924H201.132V160.013H203.22V157.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 168.43H201.132V170.519H203.22V168.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 171.924H201.132V174.013H203.22V171.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 175.431H201.132V177.52H203.22V175.431Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 178.936H201.132V181.025H203.22V178.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 126.419H204.444V128.509H206.532V126.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 129.913H204.444V132.002H206.532V129.913Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 133.419H204.444V135.508H206.532V133.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 136.912H204.444V139.001H206.532V136.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 140.419H204.444V142.508H206.532V140.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 143.924H204.444V146.014H206.532V143.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 147.418H204.444V149.507H206.532V147.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 150.925H204.444V153.014H206.532V150.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 154.419H204.444V156.508H206.532V154.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 157.924H204.444V160.013H206.532V157.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 168.43H204.444V170.519H206.532V168.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 171.924H204.444V174.013H206.532V171.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.532 175.431H204.444V177.52H206.532V175.431Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.852 117.318H241.764V119.407H243.852V117.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.852 120.823H241.764V122.912H243.852V120.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.852 124.33H241.764V126.419H243.852V124.33Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.852 127.823H241.764V129.913H243.852V127.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.852 131.329H241.764V133.418H243.852V131.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.852 134.823H241.764V136.912H243.852V134.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.852 138.33H241.764V140.419H243.852V138.33Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.852 141.835H241.764V143.924H243.852V141.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.852 152.329H241.764V154.418H243.852V152.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.852 155.835H241.764V157.924H243.852V155.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.176 117.318H245.088V119.407H247.176V117.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.176 120.823H245.088V122.912H247.176V120.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.176 124.33H245.088V126.419H247.176V124.33Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.176 127.823H245.088V129.913H247.176V127.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.176 131.329H245.088V133.418H247.176V131.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.176 134.823H245.088V136.912H247.176V134.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.176 138.33H245.088V140.419H247.176V138.33Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.176 141.835H245.088V143.924H247.176V141.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.176 155.835H245.088V157.924H247.176V155.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.488 117.318H248.4V119.407H250.488V117.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.488 120.823H248.4V122.912H250.488V120.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.488 124.33H248.4V126.419H250.488V124.33Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.488 127.823H248.4V129.913H250.488V127.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.488 131.329H248.4V133.418H250.488V131.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.488 134.823H248.4V136.912H250.488V134.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.488 138.33H248.4V140.419H250.488V138.33Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.488 141.835H248.4V143.924H250.488V141.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 117.318H251.712V119.407H253.8V117.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 120.823H251.712V122.912H253.8V120.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 124.33H251.712V126.419H253.8V124.33Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 127.823H251.712V129.913H253.8V127.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 131.329H251.712V133.418H253.8V131.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 134.823H251.712V136.912H253.8V134.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 141.835H251.712V143.924H253.8V141.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 145.329H251.712V147.418H253.8V145.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 155.835H251.712V157.924H253.8V155.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 159.341H251.712V161.431H253.8V159.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 162.835H251.712V164.924H253.8V162.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 166.341H251.712V168.43H253.8V166.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 169.847H251.712V171.937H253.8V169.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 173.341H251.712V175.43H253.8V173.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8 176.847H251.712V178.936H253.8V176.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 117.318H255.024V119.407H257.112V117.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 120.823H255.024V122.912H257.112V120.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 124.33H255.024V126.419H257.112V124.33Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 127.823H255.024V129.913H257.112V127.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 131.329H255.024V133.418H257.112V131.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 134.823H255.024V136.912H257.112V134.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 145.329H255.024V147.418H257.112V145.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 148.835H255.024V150.925H257.112V148.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 152.329H255.024V154.418H257.112V152.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 155.835H255.024V157.924H257.112V155.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 159.341H255.024V161.431H257.112V159.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 162.835H255.024V164.924H257.112V162.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 166.341H255.024V168.43H257.112V166.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 169.847H255.024V171.937H257.112V169.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 173.341H255.024V175.43H257.112V173.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 176.847H255.024V178.936H257.112V176.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 180.34H255.024V182.429H257.112V180.34Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.112 187.352H255.024V189.442H257.112V187.352Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 117.318H258.348V119.407H260.436V117.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 120.823H258.348V122.912H260.436V120.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 124.33H258.348V126.419H260.436V124.33Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 127.823H258.348V129.913H260.436V127.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 131.329H258.348V133.418H260.436V131.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 134.823H258.348V136.912H260.436V134.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 145.329H258.348V147.418H260.436V145.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 148.835H258.348V150.925H260.436V148.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 152.329H258.348V154.418H260.436V152.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 155.835H258.348V157.924H260.436V155.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 166.341H258.348V168.43H260.436V166.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 169.847H258.348V171.937H260.436V169.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 173.341H258.348V175.43H260.436V173.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 176.847H258.348V178.936H260.436V176.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 180.34H258.348V182.429H260.436V180.34Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 187.352H258.348V189.442H260.436V187.352Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.436 190.846H258.348V192.935H260.436V190.846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.508 149.88H288.42V151.969H290.508V149.88Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.508 153.374H288.42V155.463H290.508V153.374Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.508 156.879H288.42V158.968H290.508V156.879Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.508 160.386H288.42V162.475H290.508V160.386Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.508 163.88H288.42V165.969H290.508V163.88Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.508 167.385H288.42V169.474H290.508V167.385Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.508 170.879H288.42V172.968H290.508V170.879Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.508 181.385H288.42V183.474H290.508V181.385Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.508 184.892H288.42V186.981H290.508V184.892Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.508 188.397H288.42V190.486H290.508V188.397Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.832 149.88H291.744V151.969H293.832V149.88Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.832 153.374H291.744V155.463H293.832V153.374Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.832 156.879H291.744V158.968H293.832V156.879Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.832 160.386H291.744V162.475H293.832V160.386Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.832 163.88H291.744V165.969H293.832V163.88Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.832 167.385H291.744V169.474H293.832V167.385Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.832 170.879H291.744V172.968H293.832V170.879Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.056 149.88H295.056V151.969H298.056V149.88Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.056 153.374H295.056V155.463H298.056V153.374Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.056 156.879H295.056V158.968H298.056V156.879Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.056 160.386H295.056V162.475H298.056V160.386Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.056 163.88H295.056V165.969H298.056V163.88Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.056 167.385H295.056V169.474H298.056V167.385Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.056 170.879H295.056V172.968H298.056V170.879Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 154.419H112.728V156.508H114.816V154.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 157.924H112.728V160.013H114.816V157.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 161.429H112.728V163.519H114.816V161.429Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 164.925H112.728V167.014H114.816V164.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 168.43H112.728V170.519H114.816V168.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 171.924H112.728V174.013H114.816V171.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 175.431H112.728V177.52H114.816V175.431Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 178.936H112.728V181.025H114.816V178.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 182.43H112.728V184.519H114.816V182.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 185.937H112.728V188.026H114.816V185.937Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 189.43H112.728V191.519H114.816V189.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 192.936H112.728V195.025H114.816V192.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 196.441H112.728V198.53H114.816V196.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 199.936H112.728V202.025H114.816V199.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 203.442H112.728V205.531H114.816V203.442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 206.947H112.728V209.036H114.816V206.947Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 210.442H112.728V212.531H114.816V210.442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 213.948H112.728V216.037H114.816V213.948Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 217.441H112.728V219.531H114.816V217.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.816 220.947H112.728V223.036H114.816V220.947Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 154.419H116.04V156.508H118.128V154.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 157.924H116.04V160.013H118.128V157.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 161.429H116.04V163.519H118.128V161.429Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 164.925H116.04V167.014H118.128V164.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 168.43H116.04V170.519H118.128V168.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 171.924H116.04V174.013H118.128V171.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 175.431H116.04V177.52H118.128V175.431Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 178.936H116.04V181.025H118.128V178.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 182.43H116.04V184.519H118.128V182.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 185.937H116.04V188.026H118.128V185.937Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 189.43H116.04V191.519H118.128V189.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 192.936H116.04V195.025H118.128V192.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 196.441H116.04V198.53H118.128V196.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 199.936H116.04V202.025H118.128V199.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 203.442H116.04V205.531H118.128V203.442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 206.947H116.04V209.036H118.128V206.947Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 210.442H116.04V212.531H118.128V210.442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.128 213.948H116.04V216.037H118.128V213.948Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 154.419H119.352V156.508H121.44V154.419Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 157.924H119.352V160.013H121.44V157.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 161.429H119.352V163.519H121.44V161.429Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 164.925H119.352V167.014H121.44V164.925Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 168.43H119.352V170.519H121.44V168.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 171.924H119.352V174.013H121.44V171.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 175.431H119.352V177.52H121.44V175.431Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 178.936H119.352V181.025H121.44V178.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 182.43H119.352V184.519H121.44V182.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 185.937H119.352V188.026H121.44V185.937Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 189.43H119.352V191.519H121.44V189.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 192.936H119.352V195.025H121.44V192.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 196.441H119.352V198.53H121.44V196.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 199.936H119.352V202.025H121.44V199.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 203.442H119.352V205.531H121.44V203.442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 206.947H119.352V209.036H121.44V206.947Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 210.442H119.352V212.531H121.44V210.442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.44 213.948H119.352V216.037H121.44V213.948Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 179.981H100.32V182.07H102.408V179.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 183.475H100.32V185.564H102.408V183.475Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 186.98H100.32V189.069H102.408V186.98Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 190.475H100.32V192.564H102.408V190.475Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 193.98H100.32V196.07H102.408V193.98Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 197.486H100.32V199.575H102.408V197.486Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 200.981H100.32V203.07H102.408V200.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 204.486H100.32V206.575H102.408V204.486Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 207.98H100.32V210.069H102.408V207.98Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 211.486H100.32V213.575H102.408V211.486Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 214.992H100.32V217.082H102.408V214.992Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 218.486H100.32V220.575H102.408V218.486Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 221.991H100.32V224.081H102.408V221.991Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 179.981H103.632V182.07H105.72V179.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 183.475H103.632V185.564H105.72V183.475Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 186.98H103.632V189.069H105.72V186.98Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 190.475H103.632V192.564H105.72V190.475Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 193.98H103.632V196.07H105.72V193.98Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 197.486H103.632V199.575H105.72V197.486Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 200.981H103.632V203.07H105.72V200.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 204.486H103.632V206.575H105.72V204.486Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 207.98H103.632V210.069H105.72V207.98Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 211.486H103.632V213.575H105.72V211.486Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 214.992H103.632V217.082H105.72V214.992Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 218.486H103.632V220.575H105.72V218.486Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72 221.991H103.632V224.081H105.72V221.991Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 179.981H106.956V182.07H109.044V179.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 183.475H106.956V185.564H109.044V183.475Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 186.98H106.956V189.069H109.044V186.98Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 190.475H106.956V192.564H109.044V190.475Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 193.98H106.956V196.07H109.044V193.98Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 197.486H106.956V199.575H109.044V197.486Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 200.981H106.956V203.07H109.044V200.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 204.486H106.956V206.575H109.044V204.486Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 207.98H106.956V210.069H109.044V207.98Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 211.486H106.956V213.575H109.044V211.486Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 214.992H106.956V217.082H109.044V214.992Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 218.486H106.956V220.575H109.044V218.486Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 221.991H106.956V224.081H109.044V221.991Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.044 225.498H106.956V227.588H109.044V225.498Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.464 181.026H125.376V183.115H127.464V181.026Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.464 184.519H125.376V186.608H127.464V184.519Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.464 188.025H125.376V190.114H127.464V188.025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.464 191.518H125.376V193.608H127.464V191.518Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.464 195.025H125.376V197.114H127.464V195.025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.464 198.531H125.376V200.62H127.464V198.531Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.464 202.024H125.376V204.113H127.464V202.024Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.464 205.531H125.376V207.62H127.464V205.531Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.464 209.025H125.376V211.114H127.464V209.025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.464 212.53H125.376V214.619H127.464V212.53Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.464 223.036H125.376V225.125H127.464V223.036Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 181.026H128.688V183.115H130.776V181.026Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 184.519H128.688V186.608H130.776V184.519Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 188.025H128.688V190.114H130.776V188.025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 191.518H128.688V193.608H130.776V191.518Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 195.025H128.688V197.114H130.776V195.025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 198.531H128.688V200.62H130.776V198.531Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 202.024H128.688V204.113H130.776V202.024Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 205.531H128.688V207.62H130.776V205.531Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 209.025H128.688V211.114H130.776V209.025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 219.531H128.688V221.62H130.776V219.531Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 223.036H128.688V225.125H130.776V223.036Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.088 181.026H132V183.115H134.088V181.026Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.088 184.519H132V186.608H134.088V184.519Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.088 188.025H132V190.114H134.088V188.025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.088 191.518H132V193.608H134.088V191.518Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.088 195.025H132V197.114H134.088V195.025Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.088 198.531H132V200.62H134.088V198.531Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.088 202.024H132V204.113H134.088V202.024Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.088 205.531H132V207.62H134.088V205.531Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.088 216.037H132V218.126H134.088V216.037Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.088 219.531H132V221.62H134.088V219.531Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.088 223.036H132V225.125H134.088V223.036Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 127.823H162.816V129.913H164.904V127.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 131.329H162.816V133.418H164.904V131.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 134.823H162.816V136.912H164.904V134.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 138.33H162.816V140.419H164.904V138.33Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 141.835H162.816V143.924H164.904V141.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 145.329H162.816V147.418H164.904V145.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 148.835H162.816V150.925H164.904V148.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 152.329H162.816V154.418H164.904V152.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 155.835H162.816V157.924H164.904V155.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 159.341H162.816V161.431H164.904V159.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 162.835H162.816V164.924H164.904V162.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 166.341H162.816V168.43H164.904V166.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 169.847H162.816V171.937H164.904V169.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 173.341H162.816V175.43H164.904V173.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 176.847H162.816V178.936H164.904V176.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 180.34H162.816V182.429H164.904V180.34Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 183.847H162.816V185.936H164.904V183.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 190.846H162.816V192.935H164.904V190.846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 194.353H162.816V196.442H164.904V194.353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 197.847H162.816V199.936H164.904V197.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 201.352H162.816V203.441H164.904V201.352Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 204.859H162.816V206.948H164.904V204.859Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 127.823H166.128V129.913H168.216V127.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 131.329H166.128V133.418H168.216V131.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 134.823H166.128V136.912H168.216V134.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 138.33H166.128V140.419H168.216V138.33Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 141.835H166.128V143.924H168.216V141.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 145.329H166.128V147.418H168.216V145.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 148.835H166.128V150.925H168.216V148.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 152.329H166.128V154.418H168.216V152.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 155.835H166.128V157.924H168.216V155.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 159.341H166.128V161.431H168.216V159.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 162.835H166.128V164.924H168.216V162.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 166.341H166.128V168.43H168.216V166.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 169.847H166.128V171.937H168.216V169.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 173.341H166.128V175.43H168.216V173.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 176.847H166.128V178.936H168.216V176.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 180.34H166.128V182.429H168.216V180.34Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 201.352H166.128V203.441H168.216V201.352Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216 204.859H166.128V206.948H168.216V204.859Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 127.823H169.452V129.913H171.54V127.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 131.329H169.452V133.418H171.54V131.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 134.823H169.452V136.912H171.54V134.823Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 138.33H169.452V140.419H171.54V138.33Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 141.835H169.452V143.924H171.54V141.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 145.329H169.452V147.418H171.54V145.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 148.835H169.452V150.925H171.54V148.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 152.329H169.452V154.418H171.54V152.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 155.835H169.452V157.924H171.54V155.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 159.341H169.452V161.431H171.54V159.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 162.835H169.452V164.924H171.54V162.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 166.341H169.452V168.43H171.54V166.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 169.847H169.452V171.937H171.54V169.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 173.341H169.452V175.43H171.54V173.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 176.847H169.452V178.936H171.54V176.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 180.34H169.452V182.429H171.54V180.34Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 187.352H169.452V189.442H171.54V187.352Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 190.846H169.452V192.935H171.54V190.846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 194.353H169.452V196.442H171.54V194.353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 197.847H169.452V199.936H171.54V197.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54 204.859H169.452V206.948H171.54V204.859Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 171.924H150.78V174.013H152.868V171.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 175.431H150.78V177.52H152.868V175.431Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 178.936H150.78V181.025H152.868V178.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 182.43H150.78V184.519H152.868V182.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 185.937H150.78V188.026H152.868V185.937Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 189.43H150.78V191.519H152.868V189.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 192.936H150.78V195.025H152.868V192.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 199.936H150.78V202.025H152.868V199.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 203.442H150.78V205.531H152.868V203.442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 206.947H150.78V209.036H152.868V206.947Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 210.442H150.78V212.531H152.868V210.442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 213.948H150.78V216.037H152.868V213.948Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 217.441H150.78V219.531H152.868V217.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 220.947H150.78V223.036H152.868V220.947Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 224.454H150.78V226.543H152.868V224.454Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 171.924H154.104V174.013H156.192V171.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 175.431H154.104V177.52H156.192V175.431Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 178.936H154.104V181.025H156.192V178.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 182.43H154.104V184.519H156.192V182.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 185.937H154.104V188.026H156.192V185.937Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 189.43H154.104V191.519H156.192V189.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 199.936H154.104V202.025H156.192V199.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 203.442H154.104V205.531H156.192V203.442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 206.947H154.104V209.036H156.192V206.947Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 210.442H154.104V212.531H156.192V210.442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 213.948H154.104V216.037H156.192V213.948Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 217.441H154.104V219.531H156.192V217.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 220.947H154.104V223.036H156.192V220.947Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.192 224.454H154.104V226.543H156.192V224.454Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 171.924H157.416V174.013H159.504V171.924Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 175.431H157.416V177.52H159.504V175.431Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 178.936H157.416V181.025H159.504V178.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 182.43H157.416V184.519H159.504V182.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 185.937H157.416V188.026H159.504V185.937Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 189.43H157.416V191.519H159.504V189.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 196.441H157.416V198.53H159.504V196.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 199.936H157.416V202.025H159.504V199.936Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 203.442H157.416V205.531H159.504V203.442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 206.947H157.416V209.036H159.504V206.947Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 210.442H157.416V212.531H159.504V210.442Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 213.948H157.416V216.037H159.504V213.948Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 217.441H157.416V219.531H159.504V217.441Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 220.947H157.416V223.036H159.504V220.947Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.504 224.454H157.416V226.543H159.504V224.454Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 152.329H227.28V154.418H229.368V152.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 155.835H227.28V157.924H229.368V155.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 159.341H227.28V161.431H229.368V159.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 162.835H227.28V164.924H229.368V162.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 166.341H227.28V168.43H229.368V166.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 169.847H227.28V171.937H229.368V169.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 173.341H227.28V175.43H229.368V173.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 176.847H227.28V178.936H229.368V176.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 180.34H227.28V182.429H229.368V180.34Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 183.847H227.28V185.936H229.368V183.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 187.352H227.28V189.442H229.368V187.352Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 190.846H227.28V192.935H229.368V190.846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 194.353H227.28V196.442H229.368V194.353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 201.352H227.28V203.441H229.368V201.352Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 204.859H227.28V206.948H229.368V204.859Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 208.353H227.28V210.442H229.368V208.353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 211.858H227.28V213.947H229.368V211.858Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 218.859H227.28V220.948H229.368V218.859Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 222.364H227.28V224.453H229.368V222.364Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.368 225.858H227.28V227.947H229.368V225.858Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 152.329H230.592V154.418H232.68V152.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 155.835H230.592V157.924H232.68V155.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 159.341H230.592V161.431H232.68V159.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 162.835H230.592V164.924H232.68V162.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 166.341H230.592V168.43H232.68V166.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 169.847H230.592V171.937H232.68V169.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 173.341H230.592V175.43H232.68V173.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 176.847H230.592V178.936H232.68V176.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 180.34H230.592V182.429H232.68V180.34Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 183.847H230.592V185.936H232.68V183.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 187.352H230.592V189.442H232.68V187.352Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 190.846H230.592V192.935H232.68V190.846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 194.353H230.592V196.442H232.68V194.353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 204.859H230.592V206.948H232.68V204.859Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 208.353H230.592V210.442H232.68V208.353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 215.352H230.592V217.441H232.68V215.352Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 218.859H230.592V220.948H232.68V218.859Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 222.364H230.592V224.453H232.68V222.364Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68 225.858H230.592V227.947H232.68V225.858Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 152.329H233.904V154.418H235.992V152.329Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 155.835H233.904V157.924H235.992V155.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 159.341H233.904V161.431H235.992V159.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 162.835H233.904V164.924H235.992V162.835Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 166.341H233.904V168.43H235.992V166.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 169.847H233.904V171.937H235.992V169.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 173.341H233.904V175.43H235.992V173.341Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 176.847H233.904V178.936H235.992V176.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 180.34H233.904V182.429H235.992V180.34Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 183.847H233.904V185.936H235.992V183.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 187.352H233.904V189.442H235.992V187.352Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 190.846H233.904V192.935H235.992V190.846Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 194.353H233.904V196.442H235.992V194.353Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 197.847H233.904V199.936H235.992V197.847Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 204.859H233.904V206.948H235.992V204.859Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 211.858H233.904V213.947H235.992V211.858Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 215.352H233.904V217.441H235.992V215.352Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 218.859H233.904V220.948H235.992V218.859Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 222.364H233.904V224.453H235.992V222.364Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.992 225.858H233.904V227.947H235.992V225.858Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 172.296H213.768V174.385H215.856V172.296Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 175.802H213.768V177.891H215.856V175.802Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 179.295H213.768V181.385H215.856V179.295Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 182.802H213.768V184.892H215.856V182.802Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 186.308H213.768V188.397H215.856V186.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 189.801H213.768V191.891H215.856V189.801Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 200.307H213.768V202.397H215.856V200.307Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 203.814H213.768V205.903H215.856V203.814Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 207.308H213.768V209.397H215.856V207.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 210.813H213.768V212.903H215.856V210.813Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 214.307H213.768V216.396H215.856V214.307Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 217.814H213.768V219.903H215.856V217.814Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 221.319H213.768V223.408H215.856V221.319Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 172.296H217.092V174.385H219.18V172.296Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 175.802H217.092V177.891H219.18V175.802Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 179.295H217.092V181.385H219.18V179.295Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 182.802H217.092V184.892H219.18V182.802Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 186.308H217.092V188.397H219.18V186.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 189.801H217.092V191.891H219.18V189.801Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 200.307H217.092V202.397H219.18V200.307Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 203.814H217.092V205.903H219.18V203.814Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 207.308H217.092V209.397H219.18V207.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 210.813H217.092V212.903H219.18V210.813Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 214.307H217.092V216.396H219.18V214.307Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 217.814H217.092V219.903H219.18V217.814Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 224.813H217.092V226.902H219.18V224.813Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.62 57.8121H294.48V285.327H298.62V57.8121Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.08 57.8121H228.576V285.327H232.08V57.8121Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.176 57.8121H162.672V285.327H166.176V57.8121Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.88 66.8176C423.271 66.8176 430.884 59.2004 430.884 49.8041C430.884 40.4078 423.271 32.7906 413.88 32.7906C404.489 32.7906 396.876 40.4078 396.876 49.8041C396.876 59.2004 404.489 66.8176 413.88 66.8176Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.328 49.8041C428.328 57.7885 421.86 64.2722 413.868 64.2722C405.888 64.2722 399.408 57.8005 399.408 49.8041C399.408 41.8196 405.876 35.336 413.868 35.336C421.86 35.348 428.328 41.8196 428.328 49.8041Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.196 39.8861V49.9958L406.5 46.2016",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.196 39.8861V49.9958L406.5 46.2016",
    stroke: "#E0E0E0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.744 77.2634H423.576V176.535H498.744V77.2634Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.148 87.8293V131.474L466.524 130.489L468.516 87.8293H449.148Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.212 96.2706H489.948L489.72 134.476L475.872 134.692L463.212 96.2706Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.184 90.6391H444.216L441.756 124.726L432.96 126.899L437.184 90.6391Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.634 188.65H412.562V97.4231L337.634 97.4231V188.65Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.78 166.053L394.152 127.319L351.552 120.295L354.78 166.053Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.204 156.867L395.148 127.175L365.508 134.463L363.348 157.179L393.204 156.867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.875 123.548C367.548 118.873 367.548 111.294 362.875 106.619C358.203 101.944 350.628 101.944 345.956 106.619C341.284 111.294 341.284 118.873 345.956 123.548C350.628 128.223 358.203 128.223 362.875 123.548Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.328 167.457C389.328 164.251 391.932 161.646 395.136 161.646C398.34 161.646 400.944 164.251 400.944 167.457C400.944 170.663 398.34 173.268 395.136 173.268C391.932 173.268 389.328 170.663 389.328 167.457Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.756 177.663L376.992 167.457L391.08 155.835L393.756 177.663Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.968 109.021H370.668V181.866H373.968V109.021Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.528 109.021H401.268V178.648H405.528V109.021Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.936 157.18H345.156V178.972H366.936V157.18Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.668 310.29H414.924V381.886H493.668V310.29Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.704 303.974H495.804V392.884H505.704V303.974Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.92 316.966H427.464V342.648H433.92V316.966Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.668 316.966H454.212V342.648H460.668V316.966Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.364 319.187H433.908V342.648H440.364V319.187Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.212 319.187H447.756V342.648H454.212V319.187Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.756 316.966H443.592V342.648H447.756V316.966Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.592 319.187H440.364V342.648H443.592V319.187Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.124 316.966H460.668V342.648H467.124V316.966Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.58 319.187H467.124V342.648H473.58V319.187Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.428 319.187H480.972V342.648H487.428V319.187Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.96 316.966H476.796V342.648H480.96V316.966Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.796 319.187H473.568V342.648H476.796V319.187Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.644 317.71H487.416V342.648H490.644V317.71Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.195 377.921H490.651V353.439H484.195V377.921Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.437 377.921H463.893V353.439H457.437V377.921Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.734 377.915H484.19V355.655H477.734V377.915Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.886 377.915H470.342V355.655H463.886V377.915Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.356 377.921H474.52V353.439H470.356V377.921Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.511 377.915H477.74V355.655H474.511V377.915Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.988 377.921H457.444V353.439H450.988V377.921Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.528 377.915H450.984V355.655H444.528V377.915Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.679 377.915H437.135V355.655H430.679V377.915Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.149 377.921H441.313V353.439H437.149V377.921Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.301 377.921H427.465V353.439H423.301V377.921Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.305 377.915H444.533V355.655H441.305V377.915Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.457 377.915H430.685V354.178H427.457V377.915Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.272 303.974H490.632H412.428V387.157H490.632V392.884H495.912V303.974H493.272ZM490.632 377.912H417.408V347.955H490.632V377.912ZM490.632 342.684H417.408V313.22H490.632V342.684Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.055 381.876H414.799V310.28H336.055V381.876Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.082 392.884H348.982V386.124H339.082V392.884Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.685 342.646H412.141V316.964H405.685V342.646Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.939 342.646H385.395V316.964H378.939V342.646Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.236 342.652H405.692V319.191H399.236V342.652Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.387 342.652H391.844V319.191H385.387V342.652Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.845 342.646H396.009V316.964H391.845V342.646Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.013 342.652H399.241V319.191H396.013V342.652Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.737 342.646H383.193V316.964H376.737V342.646Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.289 342.652H376.745V319.191H370.289V342.652Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.441 342.652H362.897V319.191H356.441V342.652Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.899 342.646H367.063V316.964H362.899V342.646Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.054 342.652H370.282V319.191H367.054V342.652Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.206 342.652H356.434V317.714H353.206V342.652Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.64 353.43H350.184V377.912H356.64V353.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.388 353.43H376.932V377.912H383.388V353.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.096 355.663H356.64V377.923H363.096V355.663Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.944 355.663H370.488V377.923H376.944V355.663Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.476 353.43H366.312V377.912H370.476V353.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.312 355.663H363.084V377.923H366.312V355.663Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.596 353.43H379.14V377.912H385.596V353.43Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.04 355.663H385.584V377.923H392.04V355.663Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.888 355.663H399.432V377.923H405.888V355.663Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.432 353.43H395.268V377.912H399.432V353.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.428 353.43H408.264V377.912H412.428V353.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.268 355.663H392.04V377.923H395.268V355.663Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.116 354.187H405.888V377.924H409.116V354.187Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.804 303.974V392.884H339.084V387.157H417.288V303.974H339.084H336.444H333.804ZM339.084 347.967H412.308V377.924H339.084V347.967ZM339.084 313.22H412.308V342.684H339.084V313.22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 447.382C428.499 447.382 532.668 441.297 532.668 433.791C532.668 426.284 428.499 420.199 300 420.199C171.501 420.199 67.332 426.284 67.332 433.791C67.332 441.297 171.501 447.382 300 447.382Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.46 381.417C458.46 381.417 449.16 370.335 443.196 375.51C437.244 380.673 440.256 391.635 447.12 391.995C453.984 392.344 458.448 388.525 458.448 388.525V381.417H458.46Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M458.46 381.417C458.46 381.417 449.16 370.335 443.196 375.51C437.244 380.673 440.256 391.635 447.12 391.995C453.984 392.344 458.448 388.525 458.448 388.525V381.417H458.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.416 353.322C496.416 353.322 504.228 345.133 509.064 346.526C513.9 347.919 513.396 367.478 498.396 359.565L496.416 353.322Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M496.416 353.322C496.416 353.322 504.228 345.133 509.064 346.526C513.9 347.919 513.396 367.478 498.396 359.565L496.416 353.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.504 414.424C468.504 414.424 442.824 379.28 463.668 372.16C484.512 365.04 488.232 400.436 482.28 410.294C476.328 420.151 468.504 414.424 468.504 414.424Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.408 342.468C480.408 342.468 496.332 305.463 472.74 304.346C449.148 303.23 446.58 341.039 473.724 346.526L480.408 342.468Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M468.504 414.424C468.504 414.424 442.824 379.28 463.668 372.16C484.512 365.04 488.232 400.436 482.28 410.294C476.328 420.151 468.504 414.424 468.504 414.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M480.408 342.468C480.408 342.468 496.332 305.463 472.74 304.346C449.148 303.23 446.58 341.039 473.724 346.526L480.408 342.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.756 372.761C474.756 372.761 467.016 340.09 481.896 337.485C496.776 334.879 511.476 364.404 480.684 379.244C480.684 379.232 475.404 375.954 474.756 372.761Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M474.756 372.761C474.756 372.761 467.016 340.09 481.896 337.485C496.776 334.879 511.476 364.404 480.684 379.244C480.684 379.232 475.404 375.954 474.756 372.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.024 409.442H493.128L489.528 437.045H453.624L450.024 409.442Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.44 339.814C470.172 338.181 468.216 336.152 466.476 333.955C464.736 331.745 463.308 329.284 462.252 326.654C461.196 324.025 460.692 321.167 460.716 318.334C460.668 315.476 461.544 312.727 462.648 310.193C462.504 310.878 462.348 311.55 462.18 312.222L461.94 313.219C461.892 313.555 461.868 313.903 461.832 314.24C461.76 314.924 461.664 315.596 461.604 316.269L461.64 318.31C461.832 321.011 462.336 323.689 463.368 326.21C464.352 328.732 465.696 331.121 467.22 333.402C467.976 334.543 468.804 335.647 469.692 336.692C470.544 337.797 471.48 338.817 472.44 339.814Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.788 308.069C468.132 308.285 469.404 308.813 470.652 309.389C471.852 310.05 473.028 310.782 474.06 311.719C476.172 313.52 477.768 315.885 478.86 318.43C479.928 321 480.372 323.761 480.504 326.499C480.528 327.868 480.42 329.237 480.372 330.593C480.132 331.938 479.94 333.283 479.676 334.604C479.676 333.247 479.748 331.902 479.784 330.557C479.712 329.213 479.712 327.88 479.58 326.559C479.328 325.25 479.316 323.906 478.92 322.645C478.752 322.008 478.644 321.36 478.428 320.736L477.744 318.887C475.764 314.048 471.864 310.002 466.788 308.069Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.836 339.815C488.304 341.051 491.124 343.921 492.66 347.331C493.44 349.036 493.944 350.873 494.124 352.734C494.22 353.19 494.196 353.67 494.196 354.151C494.184 354.631 494.22 355.111 494.16 355.579C494.004 356.516 493.92 357.464 493.596 358.353C493.104 360.178 492.228 361.847 491.34 363.468C490.344 365.029 489.324 366.577 488.1 367.958C485.736 370.78 483.072 373.325 480.12 375.486C481.428 374.214 482.712 372.929 483.912 371.56C485.136 370.216 486.312 368.835 487.38 367.382C489.528 364.5 491.472 361.403 492.444 358.005C492.756 357.176 492.828 356.3 492.996 355.435C493.068 355.003 493.02 354.571 493.044 354.139C493.056 353.706 493.068 353.274 492.996 352.83C492.888 351.053 492.42 349.324 491.808 347.667C491.172 346.01 490.236 344.473 489.048 343.14C487.884 341.808 486.456 340.655 484.836 339.815Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.408 342.468C481.284 344.869 481.824 347.379 482.064 349.948C482.208 351.233 482.172 352.542 482.04 353.85C481.896 355.147 481.548 356.48 480.816 357.681C479.4 359.698 478.92 362.111 478.644 364.608C478.5 365.845 478.464 367.106 478.464 368.366C478.428 369.627 478.488 370.9 478.548 372.173C477.936 369.699 477.66 367.13 477.72 364.548C477.744 363.252 477.9 361.955 478.2 360.67C478.38 360.034 478.56 359.398 478.848 358.785C479.052 358.173 479.544 357.548 479.796 357.044C480.42 356.084 480.744 354.895 480.912 353.694C481.104 352.494 481.152 351.245 481.14 349.996C481.128 348.748 481.044 347.487 480.9 346.238C480.804 344.977 480.612 343.729 480.408 342.468Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.944 375.51C470.604 375.702 471.12 376.207 471.552 376.723C471.996 377.239 472.344 377.827 472.692 378.416C473.328 379.616 473.844 380.865 474.312 382.126C475.236 384.659 475.884 387.277 476.448 389.894C476.988 392.524 477.432 395.165 477.708 397.831C477.996 400.484 478.248 403.162 478.128 405.851C477.936 404.53 477.732 403.21 477.492 401.901C477.276 400.592 477.048 399.271 476.796 397.975C476.292 395.357 475.824 392.752 475.272 390.158C474.744 387.553 474.132 384.983 473.436 382.426C473.088 381.153 472.68 379.893 472.164 378.68C471.912 378.08 471.648 377.467 471.288 376.927C470.928 376.375 470.544 375.822 469.944 375.51Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.648 376.639C461.952 379.041 461.592 381.49 461.436 383.928C461.304 386.365 461.472 388.814 461.964 391.192C462.432 393.569 463.224 395.886 464.388 398.035C465.468 400.233 466.968 402.19 468.504 404.159C468.036 403.751 467.58 403.33 467.124 402.886C466.68 402.442 466.176 402.046 465.804 401.541C465.012 400.569 464.172 399.608 463.572 398.492C462.852 397.435 462.384 396.258 461.856 395.094C461.616 394.505 461.46 393.881 461.256 393.281C461.04 392.68 460.908 392.056 460.788 391.432C460.284 388.934 460.176 386.365 460.5 383.856C460.824 381.334 461.52 378.873 462.648 376.639Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.476 357.307C503.868 356.899 505.128 356.587 506.292 356.083C506.88 355.855 507.42 355.53 507.96 355.182C508.512 354.834 508.968 354.378 509.532 353.897C509.412 354.606 509.1 355.326 508.584 355.879C508.092 356.443 507.456 356.887 506.76 357.187C506.064 357.463 505.344 357.644 504.612 357.656C503.892 357.68 503.16 357.596 502.476 357.307Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.88 351.905C501.216 351.233 501.72 350.692 502.296 350.224C502.872 349.756 503.544 349.384 504.288 349.167C505.032 348.963 505.848 348.915 506.616 349.143C507.384 349.36 508.02 349.888 508.416 350.5C507.696 350.272 507.084 350.08 506.448 350.068C505.824 350.068 505.224 350.14 504.612 350.32C504 350.476 503.4 350.752 502.788 351.016L500.88 351.905Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.212 383.074C452.604 381.837 451.116 380.576 449.484 379.664C448.68 379.184 447.828 378.835 446.952 378.727C446.076 378.607 445.164 378.799 444.228 379.244C444.828 378.415 445.86 377.827 446.976 377.791C448.092 377.719 449.16 378.103 450.072 378.619C450.984 379.148 451.788 379.808 452.484 380.564C453.168 381.309 453.78 382.137 454.212 383.074Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.212 388.525C453.084 388.957 451.908 389.185 450.72 389.294C449.52 389.414 448.308 389.366 447.108 389.185C445.908 388.993 444.684 388.573 443.664 387.793C442.632 387.036 441.96 385.8 441.984 384.587C442.476 385.704 443.244 386.496 444.18 387.012C445.128 387.517 446.196 387.841 447.3 388.009C449.52 388.381 451.824 388.405 454.212 388.525Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.78 413.03C379.752 411.385 378.384 408.924 376.464 408.888C377.304 406.534 376.476 403.689 374.508 402.14C374.256 401.948 373.98 401.768 373.656 401.768C373.32 401.768 373.02 401.972 372.744 402.164C370.944 403.461 369.144 404.745 367.344 406.042C366.936 406.342 366.504 406.654 366.276 407.099C365.172 409.236 369.144 411.973 367.512 413.738C367.044 414.243 366.288 414.351 365.7 414.711C364.416 415.515 364.26 417.28 363.66 418.673C363.06 420.066 360.972 421.146 360.18 419.862C360.768 418.529 358.98 417.376 357.54 417.208C356.112 417.04 354.576 416.956 353.772 415.599C351.72 417.4 347.112 412.381 347.22 410.352C345.528 410.484 344.376 412.069 344.004 413.654C343.62 415.299 343.86 417.016 343.836 418.697C343.788 421.975 342.732 425.181 342.78 428.458C342.828 431.004 343.812 433.837 346.14 434.858C347.268 435.35 348.528 435.35 349.752 435.338C358.608 435.278 367.452 435.23 376.308 435.17C376.944 435.17 377.616 435.158 378.18 434.858C379.38 434.234 379.632 432.661 379.74 431.316C380.22 425.541 380.688 419.778 381.168 414.002C380.388 413.678 379.584 413.354 378.78 413.03Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M378.78 413.03C379.752 411.385 378.384 408.924 376.464 408.888C377.304 406.534 376.476 403.689 374.508 402.14C374.256 401.948 373.98 401.768 373.656 401.768C373.32 401.768 373.02 401.972 372.744 402.164C370.944 403.461 369.144 404.745 367.344 406.042C366.936 406.342 366.504 406.654 366.276 407.099C365.172 409.236 369.144 411.973 367.512 413.738C367.044 414.243 366.288 414.351 365.7 414.711C364.416 415.515 364.26 417.28 363.66 418.673C363.06 420.066 360.972 421.146 360.18 419.862C360.768 418.529 358.98 417.376 357.54 417.208C356.112 417.04 354.576 416.956 353.772 415.599C351.72 417.4 347.112 412.381 347.22 410.352C345.528 410.484 344.376 412.069 344.004 413.654C343.62 415.299 343.86 417.016 343.836 418.697C343.788 421.975 342.732 425.181 342.78 428.458C342.828 431.004 343.812 433.837 346.14 434.858C347.268 435.35 348.528 435.35 349.752 435.338C358.608 435.278 367.452 435.23 376.308 435.17C376.944 435.17 377.616 435.158 378.18 434.858C379.38 434.234 379.632 432.661 379.74 431.316C380.22 425.541 380.688 419.778 381.168 414.002C380.388 413.678 379.584 413.354 378.78 413.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.34 384.947H377.364H369.156H366.168H357.972H354.984H346.788H343.8H339.168L339.504 389.113L339.744 392.091L340.368 399.835L340.728 404.277L341.208 410.197L341.412 412.73L341.484 413.487L341.724 416.464L342.048 420.547L342.252 423.08L342.468 425.661L342.708 428.639L342.888 430.896L343.092 433.43L343.176 434.534H348.6H353.184H359.796H364.38H370.992H375.576H381.012L381.096 433.43L381.3 430.896L381.48 428.615L381.72 425.637L381.936 423.068L382.14 420.534L382.464 416.44L382.704 413.463L382.764 412.706L382.968 410.173L383.448 404.253L383.808 399.823L384.432 392.079L384.672 389.101L385.008 384.935H380.34V384.947ZM382.812 387.672L382.02 386.88H382.884L382.812 387.672ZM382.608 390.206L382.536 391.214L378.852 394.9L374.616 390.662L378.396 386.88H379.284L382.608 390.206ZM381.54 403.401L378.84 406.102L374.604 401.864L378.84 397.638L381.768 400.567L381.54 403.401ZM342.336 400.567L345.264 397.638L349.5 401.864L345.264 406.102L342.576 403.401L342.336 400.567ZM377.484 396.269L373.248 400.507L369.012 396.269L373.248 392.031L377.484 396.269ZM370.824 386.88H375.66L373.236 389.305L370.824 386.88ZM371.88 401.864L367.656 406.102L363.42 401.864L367.656 397.638L371.88 401.864ZM357.828 407.459L362.064 403.233L366.288 407.459L362.064 411.698L357.828 407.459ZM360.684 413.066L356.448 417.305L352.224 413.078L356.46 408.84L360.684 413.066ZM367.656 408.84L371.88 413.078L367.656 417.305L363.42 413.066L367.656 408.84ZM362.064 400.495L357.828 396.257L362.064 392.019L366.288 396.257L362.064 400.495ZM360.684 401.864L356.46 406.102L352.224 401.864L356.46 397.638L360.684 401.864ZM350.856 400.495L346.632 396.257L350.856 392.019L355.092 396.257L350.856 400.495ZM350.856 403.245L355.092 407.471L350.856 411.71L346.632 407.471L350.856 403.245ZM355.092 418.673L350.856 422.9L346.632 418.673L350.856 414.435L355.092 418.673ZM356.448 420.042L360.684 424.281L356.46 428.519L352.224 424.281L356.448 420.042ZM357.828 418.673L362.064 414.435L366.288 418.673L362.064 422.9L357.828 418.673ZM367.656 420.042L371.88 424.281L367.656 428.519L363.42 424.281L367.656 420.042ZM373.248 425.637L377.484 429.876L374.748 432.613H371.772L369.036 429.876L373.248 425.637ZM369.024 418.673L373.26 414.435L377.496 418.673L373.26 422.9L369.024 418.673ZM369.024 407.459L373.26 403.233L377.496 407.459L373.26 411.698L369.024 407.459ZM371.88 390.674L367.656 394.912L363.42 390.674L367.2 386.892H368.088L371.88 390.674ZM362.064 389.305L359.64 386.88H364.476L362.064 389.305ZM360.684 390.674L356.46 394.912L352.224 390.674L356.004 386.892H356.892L360.684 390.674ZM353.28 386.88L350.856 389.305L348.444 386.88H353.28ZM345.708 386.88L349.488 390.662L345.252 394.9L341.568 391.214L341.496 390.206L344.808 386.88H345.708ZM342.084 386.88L341.304 387.66L341.232 386.88H342.084ZM341.832 394.192L343.908 396.269L342.144 398.034L341.832 394.192ZM342.972 408.384L342.804 406.379L343.884 407.459L342.972 408.384ZM343.176 410.929L345.252 408.84L349.488 413.078L345.252 417.305L343.548 415.6L343.176 410.929ZM343.812 418.757L343.8 418.577L343.896 418.673L343.812 418.757ZM344.544 427.775L344.016 421.291L345.264 420.042L349.5 424.281L345.264 428.507L344.544 427.775ZM344.928 432.613L344.856 431.641L345.264 431.232L346.644 432.613H344.928ZM346.632 429.864L350.856 425.625L355.092 429.864L352.356 432.601H349.38L346.632 429.864ZM355.092 432.613L356.472 431.232L357.852 432.613H355.092ZM360.564 432.613L357.828 429.876L362.064 425.637L366.288 429.876L363.564 432.613H360.564ZM366.276 432.613L367.656 431.232L369.036 432.613H366.276ZM379.176 432.613H377.472L378.852 431.232L379.26 431.641L379.176 432.613ZM379.572 427.775L378.84 428.495L374.604 424.269L378.84 420.03L380.088 421.279L379.572 427.775ZM380.316 418.565L380.292 418.757L380.208 418.673L380.316 418.565ZM380.556 415.588L378.84 417.293L374.604 413.066L378.84 408.828L380.928 410.917L380.556 415.588ZM381.144 408.396L380.22 407.471L381.312 406.391L381.144 408.396ZM382.296 394.18L381.984 398.034L380.208 396.257L382.296 394.18Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.34 384.947H377.364H369.156H366.168H357.972H354.984H346.788H343.8H339.168L339.504 389.113L339.744 392.091L340.368 399.835L340.728 404.277L341.208 410.197L341.412 412.73L341.484 413.487L341.724 416.464L342.048 420.547L342.252 423.08L342.468 425.661L342.708 428.639L342.888 430.896L343.092 433.43L343.176 434.534H348.6H353.184H359.796H364.38H370.992H375.576H381.012L381.096 433.43L381.3 430.896L381.48 428.615L381.72 425.637L381.936 423.068L382.14 420.534L382.464 416.44L382.704 413.463L382.764 412.706L382.968 410.173L383.448 404.253L383.808 399.823L384.432 392.079L384.672 389.101L385.008 384.935H380.34V384.947ZM382.812 387.672L382.02 386.88H382.884L382.812 387.672ZM382.608 390.206L382.536 391.214L378.852 394.9L374.616 390.662L378.396 386.88H379.284L382.608 390.206ZM381.54 403.401L378.84 406.102L374.604 401.864L378.84 397.638L381.768 400.567L381.54 403.401ZM342.336 400.567L345.264 397.638L349.5 401.864L345.264 406.102L342.576 403.401L342.336 400.567ZM377.484 396.269L373.248 400.507L369.012 396.269L373.248 392.031L377.484 396.269ZM370.824 386.88H375.66L373.236 389.305L370.824 386.88ZM371.88 401.864L367.656 406.102L363.42 401.864L367.656 397.638L371.88 401.864ZM357.828 407.459L362.064 403.233L366.288 407.459L362.064 411.698L357.828 407.459ZM360.684 413.066L356.448 417.305L352.224 413.078L356.46 408.84L360.684 413.066ZM367.656 408.84L371.88 413.078L367.656 417.305L363.42 413.066L367.656 408.84ZM362.064 400.495L357.828 396.257L362.064 392.019L366.288 396.257L362.064 400.495ZM360.684 401.864L356.46 406.102L352.224 401.864L356.46 397.638L360.684 401.864ZM350.856 400.495L346.632 396.257L350.856 392.019L355.092 396.257L350.856 400.495ZM350.856 403.245L355.092 407.471L350.856 411.71L346.632 407.471L350.856 403.245ZM355.092 418.673L350.856 422.9L346.632 418.673L350.856 414.435L355.092 418.673ZM356.448 420.042L360.684 424.281L356.46 428.519L352.224 424.281L356.448 420.042ZM357.828 418.673L362.064 414.435L366.288 418.673L362.064 422.9L357.828 418.673ZM367.656 420.042L371.88 424.281L367.656 428.519L363.42 424.281L367.656 420.042ZM373.248 425.637L377.484 429.876L374.748 432.613H371.772L369.036 429.876L373.248 425.637ZM369.024 418.673L373.26 414.435L377.496 418.673L373.26 422.9L369.024 418.673ZM369.024 407.459L373.26 403.233L377.496 407.459L373.26 411.698L369.024 407.459ZM371.88 390.674L367.656 394.912L363.42 390.674L367.2 386.892H368.088L371.88 390.674ZM362.064 389.305L359.64 386.88H364.476L362.064 389.305ZM360.684 390.674L356.46 394.912L352.224 390.674L356.004 386.892H356.892L360.684 390.674ZM353.28 386.88L350.856 389.305L348.444 386.88H353.28ZM345.708 386.88L349.488 390.662L345.252 394.9L341.568 391.214L341.496 390.206L344.808 386.88H345.708ZM342.084 386.88L341.304 387.66L341.232 386.88H342.084ZM341.832 394.192L343.908 396.269L342.144 398.034L341.832 394.192ZM342.972 408.384L342.804 406.379L343.884 407.459L342.972 408.384ZM343.176 410.929L345.252 408.84L349.488 413.078L345.252 417.305L343.548 415.6L343.176 410.929ZM343.812 418.757L343.8 418.577L343.896 418.673L343.812 418.757ZM344.544 427.775L344.016 421.291L345.264 420.042L349.5 424.281L345.264 428.507L344.544 427.775ZM344.928 432.613L344.856 431.641L345.264 431.232L346.644 432.613H344.928ZM346.632 429.864L350.856 425.625L355.092 429.864L352.356 432.601H349.38L346.632 429.864ZM355.092 432.613L356.472 431.232L357.852 432.613H355.092ZM360.564 432.613L357.828 429.876L362.064 425.637L366.288 429.876L363.564 432.613H360.564ZM366.276 432.613L367.656 431.232L369.036 432.613H366.276ZM379.176 432.613H377.472L378.852 431.232L379.26 431.641L379.176 432.613ZM379.572 427.775L378.84 428.495L374.604 424.269L378.84 420.03L380.088 421.279L379.572 427.775ZM380.316 418.565L380.292 418.757L380.208 418.673L380.316 418.565ZM380.556 415.588L378.84 417.293L374.604 413.066L378.84 408.828L380.928 410.917L380.556 415.588ZM381.144 408.396L380.22 407.471L381.312 406.391L381.144 408.396ZM382.296 394.18L381.984 398.034L380.208 396.257L382.296 394.18Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.472 388.608H385.644C386.736 388.608 387.612 387.72 387.612 386.639V385.199C387.612 384.106 386.724 383.229 385.644 383.229H338.472C337.38 383.229 336.504 384.118 336.504 385.199V386.639C336.492 387.72 337.38 388.608 338.472 388.608Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.96 437.044H342.156C341.064 437.044 340.188 436.155 340.188 435.075V433.634C340.188 432.541 341.076 431.665 342.156 431.665H381.96C383.052 431.665 383.928 432.554 383.928 433.634V435.075C383.928 436.155 383.04 437.044 381.96 437.044Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.248 112.466H280.668V275.673H520.248V112.466Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M520.248 112.466H280.668V275.673H520.248V112.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M434.928 112.466C434.928 112.466 365.988 177.038 280.668 178.575V112.466H434.928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M520.236 197.666C520.236 197.666 472.896 192.731 426.06 219.95C379.224 247.169 332.436 272.816 280.656 260.785V275.673H520.236V197.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.728 149.363H343.164V168.994H457.728V149.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.728 177.206H343.164V196.837H457.728V177.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.424 161.093V161.609H349.44V155.978H353.304V156.494H350.04V158.487H352.944V158.991H350.04V161.081H353.424V161.093Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.216 159.172H356.316V159.676H354.216V159.172Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.572 159.147V161.597H363.996V159.195C363.996 158.307 363.54 157.839 362.784 157.839C361.92 157.839 361.368 158.403 361.368 159.363V161.585H360.792V159.183C360.792 158.295 360.336 157.827 359.568 157.827C358.704 157.827 358.152 158.391 358.152 159.351V161.573H357.6V157.346H358.152V158.115C358.452 157.611 358.992 157.31 359.7 157.31C360.396 157.31 360.948 157.61 361.2 158.199C361.5 157.647 362.112 157.31 362.868 157.31C363.9 157.334 364.572 157.935 364.572 159.147Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.312 158.98V161.598H368.76V160.937C368.508 161.369 368.004 161.634 367.308 161.634C366.348 161.634 365.76 161.129 365.76 160.409C365.76 159.761 366.18 159.208 367.392 159.208H368.736V158.956C368.736 158.236 368.328 157.839 367.536 157.839C366.984 157.839 366.48 158.032 366.132 158.332L365.88 157.912C366.312 157.551 366.936 157.335 367.596 157.335C368.688 157.335 369.312 157.888 369.312 158.98ZM368.736 160.337V159.64H367.404C366.588 159.64 366.324 159.965 366.324 160.397C366.324 160.889 366.72 161.189 367.392 161.189C368.04 161.189 368.52 160.889 368.736 160.337Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.728 156.038C370.728 155.822 370.908 155.63 371.148 155.63C371.376 155.63 371.568 155.81 371.568 156.026C371.568 156.254 371.388 156.446 371.148 156.446C370.908 156.446 370.728 156.266 370.728 156.038ZM370.86 157.371H371.436V161.597H370.86V157.371Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.02 155.63H373.596V161.597H373.02V155.63Z",
    fill: "#323048"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.844 185.767C353.844 186.968 352.98 187.688 351.54 187.688H350.028V189.465H349.428V183.834H351.528C352.98 183.834 353.844 184.566 353.844 185.767ZM353.256 185.767C353.256 184.866 352.656 184.35 351.54 184.35H350.04V187.16H351.54C352.656 187.172 353.256 186.655 353.256 185.767Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.152 186.848V189.466H357.6V188.805C357.348 189.237 356.844 189.502 356.148 189.502C355.188 189.502 354.6 188.997 354.6 188.265C354.6 187.617 355.02 187.064 356.232 187.064H357.576V186.812C357.576 186.092 357.168 185.696 356.376 185.696C355.836 185.696 355.32 185.888 354.972 186.188L354.72 185.768C355.152 185.407 355.776 185.191 356.436 185.191C357.54 185.203 358.152 185.756 358.152 186.848ZM357.588 188.193V187.497H356.268C355.452 187.497 355.188 187.821 355.188 188.253C355.188 188.745 355.584 189.045 356.256 189.045C356.892 189.057 357.36 188.757 357.588 188.193Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.112 188.985L359.364 188.529C359.7 188.793 360.276 189.009 360.864 189.009C361.668 189.009 361.992 188.733 361.992 188.313C361.992 187.208 359.256 188.085 359.256 186.404C359.256 185.707 359.856 185.203 360.924 185.203C361.476 185.203 362.064 185.359 362.424 185.599L362.172 186.055C361.8 185.803 361.356 185.695 360.924 185.695C360.156 185.695 359.82 185.995 359.82 186.392C359.82 187.532 362.556 186.668 362.556 188.301C362.556 189.033 361.908 189.501 360.816 189.501C360.132 189.513 359.46 189.285 359.112 188.985Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.048 188.985L363.3 188.529C363.636 188.793 364.212 189.009 364.8 189.009C365.604 189.009 365.928 188.733 365.928 188.313C365.928 187.208 363.192 188.085 363.192 186.404C363.192 185.707 363.792 185.203 364.86 185.203C365.412 185.203 366 185.359 366.36 185.599L366.108 186.055C365.736 185.803 365.292 185.695 364.86 185.695C364.092 185.695 363.756 185.995 363.756 186.392C363.756 187.532 366.492 186.668 366.492 188.301C366.492 189.033 365.844 189.501 364.752 189.501C364.068 189.513 363.384 189.285 363.048 188.985Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.68 185.239L372.084 189.466H371.544L370.212 185.996L368.88 189.466H368.34L366.744 185.239H367.296L368.616 188.829L369.972 185.239H370.464L371.808 188.829L373.152 185.239H373.68Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.992 187.352C373.992 186.103 374.904 185.203 376.152 185.203C377.388 185.203 378.3 186.091 378.3 187.352C378.3 188.601 377.388 189.513 376.152 189.513C374.904 189.513 373.992 188.613 373.992 187.352ZM377.712 187.352C377.712 186.368 377.04 185.707 376.14 185.707C375.24 185.707 374.568 186.368 374.568 187.352C374.568 188.337 375.24 188.997 376.14 188.997C377.04 188.997 377.712 188.349 377.712 187.352Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.576 185.203V185.755C381.528 185.755 381.48 185.743 381.444 185.743C380.556 185.743 380.016 186.308 380.016 187.304V189.465H379.44V185.239H379.992V186.067C380.268 185.503 380.796 185.203 381.576 185.203Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.424 183.498V189.465H385.872V188.625C385.524 189.201 384.936 189.501 384.24 189.501C383.04 189.501 382.14 188.625 382.14 187.34C382.14 186.067 383.04 185.191 384.24 185.191C384.912 185.191 385.5 185.479 385.848 186.031V183.486H386.424V183.498ZM385.86 187.352C385.86 186.368 385.188 185.707 384.288 185.707C383.388 185.707 382.716 186.368 382.716 187.352C382.716 188.337 383.388 188.997 384.288 188.997C385.188 188.997 385.86 188.349 385.86 187.352Z",
    fill: "#323048"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M458.928 216.852H344.364V236.483H458.928V216.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.668 208.725L357.9 207.644C357.816 207.656 357.732 207.656 357.636 207.656H356.736V208.725H356.376V205.363H357.636C358.488 205.363 359.004 205.795 359.004 206.516C359.004 207.044 358.728 207.416 358.236 207.572L359.052 208.725H358.668ZM358.656 206.516C358.656 205.975 358.296 205.675 357.624 205.675H356.736V207.356H357.624C358.296 207.356 358.656 207.044 358.656 206.516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.968 207.572H359.856C359.892 208.1 360.3 208.448 360.852 208.448C361.164 208.448 361.428 208.34 361.62 208.112L361.812 208.328C361.584 208.592 361.236 208.736 360.84 208.736C360.048 208.736 359.52 208.196 359.52 207.451C359.52 206.707 360.048 206.167 360.756 206.167C361.464 206.167 361.98 206.695 361.98 207.451C361.98 207.487 361.968 207.535 361.968 207.572ZM359.856 207.319H361.644C361.596 206.827 361.236 206.479 360.744 206.479C360.264 206.479 359.904 206.815 359.856 207.319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.84 207.259V208.724H366.504V207.295C366.504 206.767 366.24 206.491 365.784 206.491C365.268 206.491 364.944 206.827 364.944 207.403V208.724H364.608V207.295C364.608 206.767 364.344 206.491 363.876 206.491C363.36 206.491 363.036 206.827 363.036 207.403V208.724H362.7V206.202H363.024V206.659C363.204 206.359 363.528 206.178 363.948 206.178C364.368 206.178 364.692 206.359 364.848 206.707C365.028 206.383 365.388 206.178 365.844 206.178C366.432 206.178 366.84 206.539 366.84 207.259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.972 207.572H367.86C367.896 208.1 368.304 208.448 368.856 208.448C369.168 208.448 369.432 208.34 369.624 208.112L369.816 208.328C369.588 208.592 369.24 208.736 368.844 208.736C368.052 208.736 367.524 208.196 367.524 207.451C367.524 206.707 368.052 206.167 368.76 206.167C369.468 206.167 369.984 206.695 369.984 207.451C369.984 207.487 369.972 207.535 369.972 207.572ZM367.86 207.319H369.648C369.6 206.827 369.24 206.479 368.748 206.479C368.268 206.479 367.908 206.815 367.86 207.319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.844 207.259V208.724H374.508V207.295C374.508 206.767 374.244 206.491 373.788 206.491C373.272 206.491 372.948 206.827 372.948 207.403V208.724H372.612V207.295C372.612 206.767 372.348 206.491 371.88 206.491C371.364 206.491 371.04 206.827 371.04 207.403V208.724H370.704V206.202H371.028V206.659C371.208 206.359 371.532 206.178 371.952 206.178C372.372 206.178 372.696 206.359 372.852 206.707C373.032 206.383 373.392 206.178 373.848 206.178C374.436 206.178 374.844 206.539 374.844 207.259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.324 207.464C378.324 208.232 377.784 208.749 377.064 208.749C376.644 208.749 376.296 208.568 376.092 208.22V208.724H375.768V205.158H376.104V206.671C376.32 206.347 376.656 206.167 377.064 206.167C377.784 206.179 378.324 206.695 378.324 207.464ZM377.988 207.464C377.988 206.875 377.58 206.479 377.052 206.479C376.512 206.479 376.116 206.875 376.116 207.464C376.116 208.052 376.524 208.448 377.052 208.448C377.58 208.448 377.988 208.052 377.988 207.464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.216 207.572H379.104C379.14 208.1 379.548 208.448 380.1 208.448C380.412 208.448 380.676 208.34 380.868 208.112L381.06 208.328C380.832 208.592 380.484 208.736 380.088 208.736C379.296 208.736 378.768 208.196 378.768 207.451C378.768 206.707 379.296 206.167 380.004 206.167C380.712 206.167 381.228 206.695 381.228 207.451C381.228 207.487 381.216 207.535 381.216 207.572ZM379.104 207.319H380.892C380.844 206.827 380.484 206.479 379.992 206.479C379.512 206.479 379.152 206.815 379.104 207.319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.196 206.178V206.515C383.172 206.515 383.136 206.515 383.112 206.515C382.584 206.515 382.26 206.851 382.26 207.451V208.736H381.924V206.214H382.248V206.707C382.404 206.359 382.728 206.178 383.196 206.178Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.268 207.259V208.724H388.932V207.295C388.932 206.767 388.668 206.491 388.212 206.491C387.696 206.491 387.372 206.827 387.372 207.403V208.724H387.036V207.295C387.036 206.767 386.772 206.491 386.304 206.491C385.788 206.491 385.464 206.827 385.464 207.403V208.724H385.128V206.202H385.452V206.659C385.632 206.359 385.956 206.178 386.376 206.178C386.796 206.178 387.12 206.359 387.276 206.707C387.456 206.383 387.816 206.178 388.272 206.178C388.86 206.178 389.268 206.539 389.268 207.259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.4 207.572H390.288C390.324 208.1 390.732 208.448 391.284 208.448C391.596 208.448 391.86 208.34 392.052 208.112L392.244 208.328C392.016 208.592 391.668 208.736 391.272 208.736C390.48 208.736 389.952 208.196 389.952 207.451C389.952 206.707 390.48 206.167 391.188 206.167C391.896 206.167 392.412 206.695 392.412 207.451C392.412 207.487 392.4 207.535 392.4 207.572ZM390.288 207.319H392.076C392.028 206.827 391.668 206.479 391.176 206.479C390.696 206.479 390.336 206.815 390.288 207.319Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M457.728 215.651H343.164V235.282H457.728V215.651Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.764 247.747V249.068H381.504V249.38H379.764V250.809H379.404V247.447H381.708V247.759H379.764V247.747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.032 249.535C382.032 248.791 382.584 248.25 383.316 248.25C384.048 248.25 384.6 248.779 384.6 249.535C384.6 250.28 384.06 250.82 383.316 250.82C382.572 250.82 382.032 250.292 382.032 249.535ZM384.252 249.535C384.252 248.947 383.856 248.551 383.316 248.551C382.776 248.551 382.38 248.947 382.38 249.535C382.38 250.124 382.788 250.52 383.316 250.52C383.856 250.52 384.252 250.136 384.252 249.535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.568 248.262V248.598C386.544 248.598 386.508 248.598 386.484 248.598C385.956 248.598 385.632 248.935 385.632 249.535V250.82H385.296V248.298H385.62V248.79C385.788 248.43 386.1 248.262 386.568 248.262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.496 248.275V250.497C389.496 251.361 389.064 251.757 388.236 251.757C387.78 251.757 387.324 251.613 387.06 251.373L387.228 251.109C387.468 251.325 387.828 251.457 388.224 251.457C388.86 251.457 389.16 251.169 389.16 250.545V250.22C388.944 250.545 388.584 250.713 388.176 250.713C387.456 250.713 386.904 250.208 386.904 249.488C386.904 248.768 387.456 248.275 388.176 248.275C388.596 248.275 388.968 248.443 389.172 248.78V248.299H389.496V248.275ZM389.172 249.476C389.172 248.924 388.764 248.551 388.212 248.551C387.66 248.551 387.252 248.924 387.252 249.476C387.252 250.028 387.648 250.401 388.212 250.401C388.764 250.401 389.172 250.028 389.172 249.476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.204 249.535C390.204 248.791 390.756 248.25 391.488 248.25C392.22 248.25 392.772 248.779 392.772 249.535C392.772 250.28 392.232 250.82 391.488 250.82C390.744 250.82 390.204 250.292 390.204 249.535ZM392.424 249.535C392.424 248.947 392.028 248.551 391.488 248.551C390.948 248.551 390.552 248.947 390.552 249.535C390.552 250.124 390.96 250.52 391.488 250.52C392.028 250.52 392.424 250.136 392.424 249.535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.788 250.652C394.656 250.772 394.452 250.832 394.26 250.832C393.78 250.832 393.516 250.568 393.516 250.1V248.575H393.06V248.287H393.516V247.735H393.852V248.287H394.62V248.575H393.852V250.076C393.852 250.376 394.008 250.532 394.284 250.532C394.428 250.532 394.56 250.484 394.656 250.4L394.788 250.652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.372 248.599C399.372 249.32 398.856 249.752 398.004 249.752H397.104V250.809H396.744V247.447H398.004C398.856 247.447 399.372 247.879 399.372 248.599ZM399.012 248.599C399.012 248.059 398.652 247.759 397.98 247.759H397.092V249.44H397.98C398.664 249.428 399.012 249.128 399.012 248.599Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.952 249.235V250.796H401.628V250.4C401.472 250.664 401.172 250.82 400.764 250.82C400.188 250.82 399.84 250.52 399.84 250.088C399.84 249.703 400.092 249.367 400.812 249.367H401.616V249.211C401.616 248.779 401.376 248.539 400.896 248.539C400.572 248.539 400.26 248.659 400.056 248.839L399.9 248.587C400.152 248.371 400.524 248.25 400.932 248.25C401.58 248.262 401.952 248.587 401.952 249.235ZM401.604 250.039V249.631H400.812C400.32 249.631 400.164 249.823 400.164 250.088C400.164 250.376 400.404 250.568 400.8 250.568C401.196 250.556 401.472 250.376 401.604 250.039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.528 250.521L402.684 250.256C402.888 250.412 403.224 250.545 403.584 250.545C404.064 250.545 404.256 250.376 404.256 250.136C404.256 249.476 402.624 249.992 402.624 248.996C402.624 248.587 402.984 248.275 403.62 248.275C403.944 248.275 404.304 248.371 404.508 248.515L404.364 248.792C404.148 248.636 403.884 248.575 403.62 248.575C403.164 248.575 402.96 248.756 402.96 248.996C402.96 249.68 404.592 249.164 404.592 250.136C404.592 250.569 404.208 250.857 403.548 250.857C403.14 250.833 402.732 250.689 402.528 250.521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.868 250.521L405.024 250.256C405.228 250.412 405.564 250.545 405.924 250.545C406.404 250.545 406.596 250.376 406.596 250.136C406.596 249.476 404.964 249.992 404.964 248.996C404.964 248.587 405.324 248.275 405.96 248.275C406.284 248.275 406.644 248.371 406.848 248.515L406.704 248.792C406.488 248.636 406.224 248.575 405.96 248.575C405.504 248.575 405.3 248.756 405.3 248.996C405.3 249.68 406.932 249.164 406.932 250.136C406.932 250.569 406.548 250.857 405.888 250.857C405.48 250.833 405.084 250.689 404.868 250.521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.228 248.275L410.268 250.797H409.944L409.152 248.732L408.36 250.797H408.036L407.088 248.275H407.412L408.204 250.425L409.02 248.275H409.308L410.112 250.425L410.916 248.275H411.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.42 249.535C411.42 248.791 411.972 248.25 412.704 248.25C413.448 248.25 413.988 248.779 413.988 249.535C413.988 250.28 413.448 250.82 412.704 250.82C411.96 250.832 411.42 250.292 411.42 249.535ZM413.64 249.535C413.64 248.947 413.244 248.551 412.704 248.551C412.164 248.551 411.768 248.947 411.768 249.535C411.768 250.124 412.176 250.52 412.704 250.52C413.244 250.52 413.64 250.136 413.64 249.535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.944 248.262V248.598C415.92 248.598 415.884 248.598 415.86 248.598C415.332 248.598 415.008 248.935 415.008 249.535V250.82H414.672V248.298H414.996V248.79C415.164 248.43 415.488 248.262 415.944 248.262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.848 247.242V250.808H418.524V250.304C418.32 250.64 417.972 250.832 417.552 250.832C416.832 250.832 416.292 250.304 416.292 249.548C416.292 248.779 416.832 248.263 417.552 248.263C417.96 248.263 418.296 248.431 418.512 248.767V247.254H418.848V247.242ZM418.512 249.536C418.512 248.947 418.104 248.551 417.576 248.551C417.036 248.551 416.64 248.947 416.64 249.536C416.64 250.124 417.048 250.52 417.576 250.52C418.104 250.52 418.512 250.136 418.512 249.536Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.332 248.299C421.332 247.951 421.044 247.711 420.564 247.711C420.156 247.711 419.856 247.843 419.652 248.095L419.4 247.903C419.664 247.591 420.06 247.399 420.6 247.399C421.272 247.399 421.704 247.723 421.704 248.239C421.704 249.056 420.828 249.104 420.828 249.788H420.468C420.444 249.007 421.332 248.935 421.332 248.299ZM420.372 250.58C420.372 250.436 420.48 250.34 420.624 250.34C420.768 250.34 420.876 250.448 420.876 250.58C420.876 250.712 420.768 250.833 420.624 250.833C420.492 250.833 420.372 250.712 420.372 250.58Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M349.86 203.453H344.04V209.276H349.86V203.453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.804 221.788H388.764V227.672H392.4V228.512H387.804V221.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.832 225.966C392.832 224.453 393.96 223.372 395.484 223.372C397.008 223.372 398.124 224.453 398.124 225.966C398.124 227.479 397.008 228.571 395.484 228.571C393.96 228.571 392.832 227.479 392.832 225.966ZM397.188 225.966C397.188 224.885 396.456 224.177 395.484 224.177C394.5 224.177 393.768 224.873 393.768 225.966C393.768 227.058 394.512 227.767 395.484 227.767C396.456 227.767 397.188 227.046 397.188 225.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.268 223.421V227.815C404.268 229.616 403.356 230.42 401.628 230.42C400.692 230.42 399.756 230.156 399.204 229.664L399.648 228.956C400.116 229.364 400.86 229.616 401.604 229.616C402.804 229.616 403.356 229.064 403.356 227.911V227.503C402.912 228.031 402.252 228.295 401.52 228.295C400.056 228.295 398.94 227.299 398.94 225.822C398.94 224.357 400.056 223.361 401.52 223.361C402.276 223.361 402.972 223.637 403.404 224.201V223.409H404.268V223.421ZM403.368 225.834C403.368 224.849 402.636 224.177 401.616 224.177C400.584 224.177 399.864 224.837 399.864 225.834C399.864 226.818 400.596 227.491 401.616 227.491C402.636 227.491 403.368 226.806 403.368 225.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.864 221.848C405.864 221.512 406.128 221.248 406.488 221.248C406.848 221.248 407.112 221.512 407.112 221.836C407.112 222.184 406.848 222.448 406.488 222.448C406.128 222.448 405.864 222.184 405.864 221.848ZM406.02 223.421H406.944V228.512H406.02V223.421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.532 225.581V228.511H412.608V225.69C412.608 224.693 412.104 224.201 411.24 224.201C410.256 224.201 409.632 224.789 409.632 225.894V228.511H408.708V223.42H409.596V224.189C409.968 223.672 410.628 223.372 411.432 223.372C412.656 223.372 413.532 224.081 413.532 225.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.416 207.968L345.132 206.563L345.576 206.167L346.428 207.092L348.348 205.099L348.78 205.519L346.416 207.968Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.856 190.653C444.864 190.653 443.004 189.549 441.6 187.556L441.48 187.388L441.6 187.219C442.992 185.226 444.864 184.122 446.856 184.122C448.848 184.122 450.708 185.226 452.112 187.219L452.232 187.388L452.112 187.556C450.72 189.549 448.848 190.653 446.856 190.653ZM442.224 187.388C443.484 189.105 445.128 190.053 446.856 190.053C448.584 190.053 450.228 189.105 451.488 187.388C450.228 185.671 448.584 184.722 446.856 184.722C445.128 184.71 443.484 185.659 442.224 187.388Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.856 189.609C445.632 189.609 444.636 188.612 444.636 187.388C444.636 186.163 445.632 185.166 446.856 185.166C448.08 185.166 449.076 186.163 449.076 187.388C449.088 188.612 448.092 189.609 446.856 189.609ZM446.856 185.755C445.956 185.755 445.236 186.487 445.236 187.376C445.236 188.276 445.968 188.996 446.856 188.996C447.756 188.996 448.476 188.264 448.476 187.376C448.488 186.487 447.756 185.755 446.856 185.755Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.183 183.638L443.106 190.719L443.53 191.144L450.607 184.063L450.183 183.638Z",
    fill: "#323048"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.46 140.443L386.7 139.962C387.12 140.37 387.864 140.683 388.644 140.683C389.748 140.683 390.228 140.226 390.228 139.638C390.228 138.029 386.604 139.014 386.604 136.841C386.604 135.976 387.276 135.232 388.776 135.232C389.436 135.232 390.132 135.424 390.6 135.748L390.396 136.24C389.892 135.916 389.304 135.748 388.788 135.748C387.708 135.748 387.228 136.228 387.228 136.817C387.228 138.425 390.852 137.453 390.852 139.602C390.852 140.467 390.168 141.211 388.656 141.211C387.768 141.211 386.904 140.899 386.46 140.443Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.932 135.339C391.932 135.111 392.124 134.919 392.364 134.919C392.604 134.919 392.796 135.099 392.796 135.327C392.796 135.567 392.616 135.759 392.364 135.759C392.124 135.771 391.932 135.579 391.932 135.339ZM392.064 136.732H392.664V141.15H392.064V136.732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.424 136.732V140.622C398.424 142.147 397.68 142.831 396.216 142.831C395.412 142.831 394.62 142.591 394.152 142.147L394.452 141.691C394.872 142.063 395.508 142.291 396.192 142.291C397.308 142.291 397.824 141.775 397.824 140.682V140.118C397.452 140.682 396.828 140.97 396.096 140.97C394.836 140.97 393.876 140.082 393.876 138.821C393.876 137.548 394.836 136.684 396.096 136.684C396.84 136.684 397.476 136.984 397.848 137.572V136.72H398.424V136.732ZM397.836 138.833C397.836 137.873 397.128 137.224 396.156 137.224C395.184 137.224 394.488 137.885 394.488 138.833C394.488 139.794 395.184 140.454 396.156 140.454C397.128 140.454 397.836 139.794 397.836 138.833Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.16 138.593V141.162H403.56V138.653C403.56 137.716 403.068 137.236 402.228 137.236C401.28 137.236 400.68 137.825 400.68 138.833V141.15H400.08V136.732H400.656V137.548C400.98 137.008 401.568 136.696 402.336 136.696C403.416 136.696 404.16 137.32 404.16 138.593Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.844 135.339C407.844 135.111 408.036 134.919 408.276 134.919C408.516 134.919 408.708 135.099 408.708 135.327C408.708 135.567 408.528 135.759 408.276 135.759C408.036 135.771 407.844 135.579 407.844 135.339ZM407.976 136.732H408.576V141.15H407.976V136.732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.3 138.593V141.162H413.7V138.653C413.7 137.716 413.208 137.236 412.368 137.236C411.42 137.236 410.82 137.825 410.82 138.833V141.15H410.22V136.732H410.796V137.548C411.12 137.008 411.708 136.696 412.476 136.696C413.568 136.696 414.3 137.32 414.3 138.593Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.536 112.034H183.06C177.192 112.034 172.44 116.789 172.44 122.66V152.677C172.44 158.548 177.192 163.302 183.06 163.302H193.128L184.692 179.992L200.268 163.302H217.536C223.404 163.302 228.156 158.548 228.156 152.677V122.66C228.144 116.789 223.392 112.034 217.536 112.034Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M217.536 112.034H183.06C177.192 112.034 172.44 116.789 172.44 122.66V152.677C172.44 158.548 177.192 163.302 183.06 163.302H193.128L184.692 179.992L200.268 163.302H217.536C223.404 163.302 228.156 158.548 228.156 152.677V122.66C228.144 116.789 223.392 112.034 217.536 112.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.391 149.644C219.074 142.958 219.074 132.117 212.391 125.431C205.709 118.745 194.874 118.745 188.191 125.431C181.509 132.117 181.509 142.958 188.191 149.644C194.874 156.33 205.709 156.33 212.391 149.644Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.504 145.184C198.048 145.184 197.604 144.98 197.304 144.632L190.596 136.719C190.032 136.059 190.116 135.063 190.776 134.498C191.436 133.934 192.432 134.018 192.996 134.678L198.516 141.174L207.624 130.44C208.188 129.78 209.184 129.696 209.844 130.26C210.504 130.824 210.588 131.821 210.024 132.481L199.716 144.632C199.404 144.98 198.96 145.184 198.504 145.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.988 434.847H315.828C316.584 434.847 317.196 434.234 317.196 433.478V429.024C317.196 428.267 316.584 427.655 315.828 427.655H249.588V284.979H314.7C316.08 284.979 317.208 283.863 317.208 282.47V277.775H246C244.008 277.775 242.4 279.384 242.4 281.377V431.245C242.388 433.226 244.008 434.847 245.988 434.847Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.388 281.377V431.233C242.388 433.226 243.996 434.835 245.988 434.835H315.828C316.584 434.835 317.196 434.222 317.196 433.466V429.012C317.196 428.255 316.584 427.631 315.828 427.631H249.588V284.979H314.7C316.08 284.979 317.196 283.851 317.196 282.47V277.775H245.988C243.996 277.775 242.388 279.384 242.388 281.377Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M242.388 281.377V319.594C244.788 320.207 247.188 320.795 249.588 321.359V284.979H314.7C316.08 284.979 317.196 283.851 317.196 282.47V277.775H245.988C243.996 277.775 242.388 279.384 242.388 281.377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.1 414.736L144.744 412.239V374.61H154.8V412.227L183.54 414.736C186.072 414.988 188.004 417.114 188.004 419.659V423.477H150.756H148.884H111.636V419.659C111.636 417.114 113.568 414.988 116.1 414.736Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M116.1 414.736L144.744 412.239V374.61H154.8V412.227L183.54 414.736C186.072 414.988 188.004 417.114 188.004 419.659V423.477H150.756H148.884H111.636V419.659C111.636 417.114 113.568 414.988 116.1 414.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.74 428.208C178.74 431.846 181.692 434.8 185.328 434.8C188.964 434.8 191.916 431.846 191.916 428.208C191.916 424.57 188.964 421.616 185.328 421.616C181.68 421.628 178.74 424.57 178.74 428.208Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9 428.208C120.9 431.846 117.948 434.8 114.312 434.8C110.676 434.8 107.724 431.846 107.724 428.208C107.724 424.57 110.676 421.616 114.312 421.616C117.96 421.628 120.9 424.57 120.9 428.208Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.456 382.283H152.076C154.536 382.283 156.528 380.289 156.528 377.828V345.446H142.992V377.828C143.004 380.289 144.996 382.283 147.456 382.283Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M147.456 382.283H152.076C154.536 382.283 156.528 380.289 156.528 377.828V345.446H142.992V377.828C143.004 380.289 144.996 382.283 147.456 382.283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.072 271.004C120.072 271.004 123.168 333.235 136.572 343.945H122.244C122.244 343.945 109.464 322.741 108.516 271.004H120.072Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M120.072 271.004C120.072 271.004 123.168 333.235 136.572 343.945H122.244C122.244 343.945 109.464 322.741 108.516 271.004H120.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.412 338.782H118.908C115.932 338.782 113.52 341.195 113.52 344.173V349.095H187.812V344.173C187.8 341.195 185.388 338.782 182.412 338.782Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46 343.944H112.848C111.648 343.944 110.676 344.916 110.676 346.117V346.934C110.676 348.134 111.648 349.107 112.848 349.107H188.46C189.66 349.107 190.632 348.134 190.632 346.934V346.117C190.632 344.916 189.66 343.944 188.46 343.944Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M188.46 343.944H112.848C111.648 343.944 110.676 344.916 110.676 346.117V346.934C110.676 348.134 111.648 349.107 112.848 349.107H188.46C189.66 349.107 190.632 348.134 190.632 346.934V346.117C190.632 344.916 189.66 343.944 188.46 343.944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.996 284.619H128.94C135.66 284.619 140.52 278.58 139.788 271.124L138.804 261.17C138.072 253.714 132.024 247.675 125.304 247.675H102.36C95.6402 247.675 90.7802 253.714 91.5122 261.17L92.4962 271.124C93.2282 278.58 99.2762 284.619 105.996 284.619Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.752 230.937L182.856 234.323C183.24 235.475 183.648 236.628 184.068 237.781C184.896 240.074 185.784 242.331 186.708 244.504C187.644 246.678 188.664 248.779 189.744 250.664C190.824 252.525 192.048 254.23 193.02 255.106C193.632 255.779 195.456 256.607 197.532 257.159C199.632 257.688 201.972 258.132 204.372 258.408C209.172 259.008 214.296 259.249 219.276 259.453L220.164 266.164C214.86 267.593 209.604 268.422 204.048 268.722C201.276 268.83 198.432 268.842 195.432 268.446C193.92 268.242 192.372 267.953 190.728 267.461C189.912 267.221 189.06 266.897 188.184 266.489C187.344 266.116 186.324 265.516 185.568 264.964C182.412 262.683 180.48 260.173 178.752 257.688C177.036 255.202 175.656 252.693 174.42 250.16C173.172 247.638 172.104 245.081 171.144 242.511C170.676 241.227 170.22 239.93 169.788 238.621C169.344 237.3 168.972 236.052 168.588 234.575L181.752 230.937Z",
    fill: "#EDBAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.86 224.61C179.64 225.907 183.084 231.346 192.576 253.162C192.576 253.162 194.124 255.839 201.828 257.496L201.12 269.755C201.12 269.755 190.104 269.275 187.548 267.498C184.992 265.721 169.668 240.519 169.668 240.519L175.86 224.61Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M201.84 257.496L201.132 269.743C201.132 269.743 192.3 269.359 188.616 268.002C188.184 267.846 187.824 267.678 187.56 267.498C186.084 266.465 180.324 257.592 175.74 250.292C172.392 244.985 169.68 240.507 169.68 240.507L175.86 224.61C179.64 225.907 183.084 231.346 192.588 253.15C192.588 253.15 194.124 255.827 201.84 257.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M188.616 268.002C188.184 267.846 187.824 267.678 187.56 267.498C186.084 266.466 180.324 257.593 175.74 250.293C177.708 243.449 179.964 238.094 179.964 238.094C179.964 238.094 188.784 255.708 188.616 268.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.648 260.066L225.252 256.956L224.196 268.483C224.196 268.483 216.3 269.491 215.328 265.337L216.648 260.066Z",
    fill: "#EDBAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.38 259.298L231.06 268.783L224.196 268.495L225.252 256.956L232.38 259.298Z",
    fill: "#EDBAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.9 256.956L206.292 258.277L204.684 270.2L200.292 270.956L201.9 256.956Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.088 300.336C182.088 300.336 240.156 323.245 253.656 332.838C267.156 342.42 301.212 407.016 301.212 407.016L287.136 417.87C287.136 417.87 246.528 358.869 241.572 354.871C236.616 350.872 171.936 331.025 171.936 331.025L182.088 300.336Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M301.224 407.016L287.148 417.87C287.148 417.87 277.668 404.098 267.312 389.414C256.236 373.697 244.152 356.936 241.584 354.871C237.96 351.941 202.404 340.535 183.552 334.627C176.616 332.442 171.948 331.013 171.948 331.013L182.1 300.336C182.1 300.336 240.156 323.257 253.668 332.838C267.168 342.42 301.224 407.016 301.224 407.016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.78 430.129L310.56 423.309L299.472 406.151L292.704 412.971L303.78 430.129Z",
    fill: "#EDBAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.704 412.971L299.472 406.163L305.808 415.96L298.8 422.432L292.704 412.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.736 422.565C311.76 422.577 311.784 422.601 311.808 422.589C311.832 422.577 311.856 422.553 311.868 422.529C312.672 422.24 313.44 421.856 314.16 421.4C314.736 421.1 315.168 420.608 315.396 420.007C315.48 419.551 315.3 419.083 314.928 418.819C314.724 418.614 314.436 418.518 314.148 418.578C313.488 418.735 312.84 419.671 312.348 420.572C312.372 419.623 312.216 418.65 311.796 418.23C311.508 417.954 311.088 417.894 310.752 418.11C310.44 418.266 310.236 418.53 310.164 418.867C309.888 420.163 311.64 422.253 311.724 422.373C311.736 422.385 311.628 422.505 311.64 422.517C311.676 422.541 311.7 422.565 311.736 422.565ZM311.796 421.676C311.76 421.748 311.736 421.82 311.712 421.88C311.184 421.136 310.404 419.827 310.572 419.059C310.596 418.879 310.704 418.723 310.86 418.626L310.956 418.566C311.244 418.422 311.4 418.506 311.484 418.602C311.916 419.083 312.024 420.62 311.796 421.676ZM312.204 421.964C312.732 420.752 313.608 419.191 314.268 419.047C314.412 419.011 314.556 419.059 314.652 419.167C314.88 419.347 315 419.635 314.964 419.923C314.832 420.548 313.812 421.292 312.204 421.964Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.428 421.951L301.476 427.954C301.152 428.146 301.056 428.567 301.248 428.891V428.903L305.568 436.287C306.084 437.055 307.128 437.271 307.908 436.767C310.992 434.618 312.36 433.441 316.284 430.764C318.696 429.131 323.616 426.141 326.568 423.404C329.52 420.654 326.724 417.821 325.236 418.721C321.696 420.846 315.54 421.759 312.108 421.495C311.508 421.447 310.92 421.615 310.428 421.951Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.784 422.588L305.364 410.87L301.308 402.609L282.264 415.829L287.784 422.588Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.784 422.588L305.364 410.87L301.308 402.609L282.264 415.829L287.784 422.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M267.312 389.413C256.236 373.697 244.152 356.935 241.584 354.87C237.96 351.941 202.404 340.534 183.552 334.627L181.356 311.754L188.244 310.529L189.024 312.282C189.024 312.282 232.056 322.044 244.212 328.143C252.06 332.081 262.584 370.599 267.312 389.413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.732 424.833C264.756 424.845 264.768 424.881 264.792 424.881C264.816 424.881 264.84 424.869 264.864 424.845C265.716 424.833 266.568 424.737 267.396 424.545C268.032 424.46 268.62 424.136 269.028 423.632C269.256 423.236 269.244 422.732 268.98 422.347C268.86 422.083 268.608 421.891 268.32 421.855C267.648 421.783 266.724 422.455 265.956 423.14C266.292 422.251 266.472 421.291 266.208 420.75C266.028 420.402 265.656 420.198 265.272 420.282C264.924 420.33 264.648 420.51 264.456 420.798C263.772 421.939 264.72 424.485 264.768 424.629L264.912 424.545L264.768 424.641C264.768 424.653 264.636 424.737 264.648 424.749C264.672 424.797 264.708 424.821 264.732 424.833ZM265.092 424.016C265.032 424.076 264.984 424.124 264.936 424.184C264.684 423.308 264.384 421.807 264.792 421.135C264.876 420.979 265.032 420.858 265.2 420.822L265.308 420.798C265.632 420.75 265.752 420.883 265.8 421.003C266.064 421.615 265.644 423.092 265.092 424.016ZM265.368 424.424C266.268 423.464 267.612 422.275 268.284 422.359C268.428 422.371 268.548 422.467 268.608 422.599C268.764 422.84 268.776 423.152 268.656 423.416C268.32 423.956 267.12 424.328 265.368 424.424Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.724 429.336L263.376 425.145L258.228 404.506L249.588 408.708L254.724 429.336Z",
    fill: "#EDBAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.588 408.708L258.228 404.518L261.168 416.32L252.408 420.078L249.588 408.708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.7 423.825L253.26 426.526C252.888 426.598 252.66 426.97 252.732 427.331V427.343L254.364 435.747C254.592 436.648 255.504 437.188 256.416 436.972C260.04 435.975 261.72 435.315 266.304 434.09C269.124 433.358 274.752 432.169 278.448 430.548C282.144 428.939 280.452 425.325 278.748 425.686C274.704 426.514 268.596 425.325 265.44 423.945C264.888 423.717 264.276 423.669 263.7 423.825Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.44 408.431C262.44 408.431 247.812 334.938 244.824 330.556C239.94 323.4 181.356 311.753 181.356 311.753L188.232 310.517L180.276 289.421L128.112 291.474C128.112 291.474 129.204 325.957 134.508 335.203C139.812 344.448 218.292 348.698 223.38 350.787C228.468 352.876 244.056 410.545 244.056 410.545L262.44 408.431Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M262.44 408.431C262.44 408.431 247.812 334.938 244.824 330.556C239.94 323.4 181.356 311.753 181.356 311.753L188.232 310.517L180.276 289.421L128.112 291.474C128.112 291.474 129.204 325.957 134.508 335.203C139.812 344.448 218.292 348.698 223.38 350.787C228.468 352.876 244.056 410.545 244.056 410.545L262.44 408.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.356 417.077L264.828 411.854L263.736 402.717L241.392 408.877L244.356 417.077Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M244.356 417.077L264.828 411.854L263.736 402.717L241.392 408.877L244.356 417.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.624 292.279L129.504 292.014L129.18 296.601L145.284 296.985L144.624 292.279Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.952 292.196L147.612 296.95L181.356 296.47L180.264 292.136L146.952 292.196Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.188 293.06L163.632 296.205C163.74 296.974 164.46 297.574 165.252 297.55L170.652 297.382C171.432 297.358 171.984 296.722 171.876 295.953L171.432 292.808C171.324 292.039 170.604 291.439 169.812 291.463L164.412 291.631C163.62 291.643 163.08 292.291 163.188 293.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.432 291.356H178.992C180.228 291.356 181.272 290.431 181.428 289.219C187.548 241.24 175.86 224.61 175.86 224.61C171.408 223.338 166.872 222.413 162.276 221.849C155.568 221.321 148.836 221.165 142.104 221.417C137.508 221.537 132.924 221.993 128.4 222.773C125.94 223.806 123.504 234.516 125.94 267.847C126.576 276.575 126.684 284.116 126.612 288.534C126.6 290.083 127.86 291.356 129.432 291.356Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.912 241.599H178.464L179.184 252.993L174.06 256.319L168.912 253.774V241.599Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M181.428 289.218C181.272 290.443 180.228 291.355 178.992 291.355H129.432C127.872 291.355 126.6 290.082 126.624 288.522C126.684 284.103 126.588 276.563 125.952 267.834C125.604 263.043 125.352 258.709 125.196 254.819C124.788 245.393 124.908 238.49 125.316 233.543C125.916 226.315 127.152 223.301 128.4 222.761C132.936 221.98 137.52 221.524 142.116 221.404C148.836 221.164 155.568 221.308 162.276 221.836C166.872 222.413 171.408 223.337 175.86 224.61C175.86 224.61 187.548 241.239 181.428 289.218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.56 220.911L158.568 226.374L159.216 221.787C157.656 219.05 157.26 217.321 158.58 214.139L147.888 201.856C148.176 208.148 147.036 216.745 142.56 220.911Z",
    fill: "#EDBAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.688 228.753L155.832 230.049L158.58 231.778C158.58 231.778 162.228 252.742 161.208 270.428L164.28 272.949L167.52 270.344C167.52 270.344 163.488 237.854 162.036 231.514L162.66 230.001L164.136 226.855L161.4 225.427L157.08 226.375H154.056L152.688 228.753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.244 206.864L158.568 214.14C158.088 215.256 157.704 216.409 157.428 217.586C154.752 216.781 151.452 213.215 151.584 210.31C151.596 209.133 151.812 207.956 152.244 206.864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.556 218.005C143.556 218.005 149.772 222.34 157.98 225.509C157.98 225.509 158.952 221.871 157.98 218.702L165.048 222.232C165.048 222.232 165.636 227.719 164.004 230.576L158.82 226.782L152.988 231.537C152.988 231.537 141.948 227.274 140.22 221.487L143.556 218.005Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M179.568 260.653L163.176 273.849C139.68 279.083 129.348 264.423 125.196 254.818C124.788 245.393 124.908 238.489 125.316 233.542C130.956 233.278 137.976 233.278 139.872 234.731C143.172 237.264 154.668 255.022 156.384 256.319C158.112 257.627 179.568 260.653 179.568 260.653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.88 259.97L197.484 256.86L196.428 268.386C196.428 268.386 188.532 269.395 187.56 265.24L188.88 259.97Z",
    fill: "#EDBAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.612 259.201L203.292 268.698L196.428 268.398L197.484 256.872L204.612 259.201Z",
    fill: "#EDBAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.828 236.713L140.772 240.411C141.444 241.672 142.14 242.908 142.86 244.145C144.252 246.618 145.716 249.032 147.228 251.325C148.752 253.594 150.336 255.78 151.968 257.485C152.76 258.349 153.564 259.069 154.212 259.538C154.416 259.694 154.452 259.694 154.512 259.742C154.56 259.802 154.788 259.862 154.92 259.934C155.1 260.006 155.34 260.066 155.544 260.138L156.312 260.33C158.532 260.822 161.34 260.978 164.136 261.026C166.956 261.075 169.86 260.978 172.776 260.846C178.608 260.546 184.584 260.09 190.464 259.562L191.892 266.189C185.988 268.098 180.084 269.635 173.964 270.788C170.916 271.388 167.808 271.821 164.616 272.157C161.4 272.445 158.16 272.625 154.416 272.217C153.924 272.145 153.468 272.085 152.964 271.989C152.448 271.869 151.956 271.784 151.404 271.628C150.828 271.448 150.324 271.328 149.688 271.052C149.064 270.788 148.416 270.5 147.984 270.248C146.028 269.179 144.504 267.99 143.112 266.778C140.4 264.304 138.216 261.759 136.26 259.117C134.292 256.488 132.54 253.798 130.92 251.073C130.128 249.692 129.36 248.311 128.616 246.919C127.86 245.502 127.176 244.157 126.456 242.572L138.828 236.713Z",
    fill: "#EDBAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.4 222.76C112.92 228.343 132.996 266.933 141.432 271.255C149.868 275.577 164.148 273.74 164.148 273.74L165.156 260.329C165.156 260.329 157.764 259.428 155.556 258.9C152.052 258.06 144.936 242.523 140.16 234.07C135.384 225.618 128.4 222.76 128.4 222.76Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.4 222.76C112.92 228.343 132.996 266.933 141.432 271.255C149.868 275.577 164.148 273.74 164.148 273.74L165.156 260.329C165.156 260.329 157.764 259.428 155.556 258.9C152.052 258.06 144.936 242.523 140.16 234.07C135.384 225.618 128.4 222.76 128.4 222.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.176 259.394L161.916 274.966L166.356 274.138L167.52 260.222L163.176 259.394Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.416 189.202C176.028 192.792 174.48 199.792 169.98 196.838C165.48 193.885 174.348 183.031 175.416 189.202Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.964 190.486C148.236 199.275 146.772 204.33 150 209.865C154.848 218.197 166.596 216.937 170.928 208.82C174.828 201.52 177 188.385 169.404 182.802C161.916 177.315 151.704 181.709 149.964 190.486Z",
    fill: "#EDBAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.776 180.796L155.724 180.34L155.988 186.055C155.796 185.947 155.592 185.839 155.412 185.731C155.412 185.731 154.776 194.076 150.024 196.921C143.568 191.999 141.672 183.954 145.776 180.796Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.744 196.826C144.852 199.227 146.064 201.353 147.564 202.661C149.808 204.618 152.232 202.913 152.7 200.128C153.12 197.618 152.46 193.572 149.688 192.696C146.952 191.819 144.624 194.064 144.744 196.826Z",
    fill: "#EDBAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.504 196.213C162.324 196.921 162.54 197.582 163.008 197.702C163.476 197.822 163.992 197.342 164.184 196.633C164.364 195.925 164.148 195.264 163.68 195.144C163.212 195.036 162.684 195.505 162.504 196.213Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.484 198.219C170.304 198.927 170.52 199.588 170.988 199.708C171.444 199.828 171.972 199.347 172.164 198.639C172.344 197.931 172.128 197.27 171.66 197.15C171.192 197.042 170.676 197.522 170.484 198.219Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.856 197.93C167.856 197.93 168.48 202.252 169.764 204.606C168.24 205.398 166.26 204.33 166.26 204.33L167.856 197.93Z",
    fill: "#E3A099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.772 206.072C162.048 206.18 162.348 206.288 162.672 206.36C162.792 206.384 162.9 206.324 162.936 206.204C162.972 206.084 162.9 205.976 162.78 205.94C159.672 205.159 158.796 202.638 158.784 202.614C158.748 202.506 158.628 202.446 158.508 202.482C158.4 202.518 158.34 202.638 158.376 202.758C158.412 202.866 159.18 205.039 161.772 206.072Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.716 193.02C160.86 193.08 161.016 193.056 161.148 192.96C162.648 191.772 164.148 192.24 164.172 192.252C164.4 192.324 164.64 192.204 164.712 191.976C164.784 191.748 164.664 191.508 164.448 191.435C164.364 191.411 162.48 190.811 160.62 192.288C160.428 192.432 160.404 192.708 160.548 192.888C160.584 192.96 160.644 192.996 160.716 193.02Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.648 196.346C174.72 196.382 174.804 196.382 174.9 196.37C175.128 196.322 175.284 196.094 175.236 195.865C174.768 193.548 172.944 192.828 172.86 192.792C172.644 192.708 172.392 192.816 172.308 193.032C172.224 193.248 172.332 193.5 172.548 193.584C172.62 193.608 174.024 194.185 174.396 196.046C174.42 196.19 174.516 196.298 174.648 196.346Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.328 187.869C152.328 187.869 152.544 188.073 152.928 188.289C153.696 188.733 155.124 189.262 156.768 188.445C159.24 187.233 160.02 180.197 167.064 183.775C167.064 183.775 169.476 183.042 171.288 185.264C173.1 187.485 171.852 195.589 175.716 194.473C179.58 193.356 178.908 192.155 178.908 192.155C178.908 192.155 177.828 192.84 177.18 192.299C177.18 192.299 179.208 190.619 178.236 188.253C178.236 188.253 177.3 189.358 176.664 189.142C176.664 189.142 177.84 184.999 175.596 179.404C173.364 173.809 159.624 175.058 159.624 175.058C159.624 175.058 157.896 172.164 151.692 174.181C145.488 176.199 142.656 183.679 143.64 186.932",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.24 267.486L233.352 264.148H196.956L180.204 265.817L179.568 267.486H234.24Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M234.24 267.486L233.352 264.148H196.956L180.204 265.817L179.568 267.486H234.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M196.956 264.148V267.486H234.24L233.352 264.148H196.956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.268 248.107C209.112 249.872 210.396 251.312 212.16 251.312H267.912C269.676 251.312 271.236 249.872 271.404 248.107L274.716 212.399C274.752 212.026 274.728 211.678 274.644 211.354C274.332 210.093 273.228 209.193 271.824 209.193H216.072C214.308 209.193 212.748 210.634 212.58 212.399L209.268 248.107Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M209.268 248.107C209.112 249.872 210.396 251.312 212.16 251.312H267.912C269.676 251.312 271.236 249.872 271.404 248.107L274.716 212.399C274.752 212.026 274.728 211.678 274.644 211.354C274.332 210.093 273.228 209.193 271.824 209.193H216.072C214.308 209.193 212.748 210.634 212.58 212.399L209.268 248.107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M212.364 251.312H267.912C269.676 251.312 271.236 249.872 271.404 248.107L274.716 212.399C274.752 212.026 274.728 211.678 274.644 211.354H219.096C217.332 211.354 215.772 212.795 215.604 214.56L212.292 250.268C212.256 250.64 212.28 250.988 212.364 251.312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.656 229.413H239.124L242.196 262.455L223.968 265.193V267.486H262.368V265.193L254.508 262.455L250.656 229.413Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M250.656 229.413H239.124L242.196 262.455L223.968 265.193V267.486H262.368V265.193L254.508 262.455L250.656 229.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M239.124 229.413L247.668 266.97L254.508 266.766L250.656 229.413H239.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.928 434.847H213.768C214.524 434.847 215.136 434.234 215.136 433.478V429.024C215.136 428.267 214.524 427.655 213.768 427.655H147.528V284.979H212.64C214.02 284.979 215.148 283.863 215.148 282.47V277.775H143.94C141.948 277.775 140.34 279.384 140.34 281.377V431.245C140.328 433.226 141.936 434.847 143.928 434.847Z",
    fill: "#323048"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.928 434.847H213.768C214.524 434.847 215.136 434.234 215.136 433.478V429.024C215.136 428.267 214.524 427.655 213.768 427.655H147.528V284.979H212.64C214.02 284.979 215.148 283.863 215.148 282.47V277.775H143.94C141.948 277.775 140.34 279.384 140.34 281.377V431.245C140.328 433.226 141.936 434.847 143.928 434.847Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.988 278.964H319.092C320.376 278.964 321.42 277.92 321.42 276.635V270.956H132.66V276.623C132.648 277.92 133.692 278.964 134.988 278.964Z",
    fill: "#007144"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M132.665 274.962H321.425V270.964H132.665V274.962Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.7 272H325.38C326.628 272 327.636 270.991 327.636 269.743C327.636 268.494 326.628 267.485 325.38 267.485H128.7C127.452 267.485 126.444 268.494 126.444 269.743C126.444 270.991 127.452 272 128.7 272Z",
    fill: "#007144"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 447.382,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInFrame);
export default __webpack_public_path__ + "static/media/sign-In-frame.87e1a74048a9faba21e7c4af42d5574f.svg";
export { ForwardRef as ReactComponent };